import React, { Component, ReactElement } from "react";
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  IonItem,
  IonList,
  IonButtons,
  IonButton,
  IonGrid,
  IonRow,
  IonCol,
  IonRadio,
  IonRadioGroup,
  IonInput,
  IonBackButton,
  withIonLifeCycle,
  IonLabel,
  IonModal,
  IonCheckbox,
} from "@ionic/react";
import { RouteComponentProps, withRouter } from "react-router";

import _ from "lodash";

// Images
import iconClose from "../../assets/Button_Close@3x.png";
import iconSearchInactive from "../../assets/Button_Search_1 Default@3x.png";
import iconSearchActive from "../../assets/Button_Search_2 Active@3x.png";
import iconFilterActive from "../../assets/Button_Filter_2 Active@3x.png";
import iconFilterInactive from "../../assets/Button_Filter_1 Default@3x.png";
import iconClearSearch from "../../assets/Button_Cancel@3x.png";
import iconSearch from "../../assets/Button_Search_Small@3x.png";
import iconSearchDark from "../../assets/Button_Search_Small_Dark@3x.png";
import iconDisclosureDown from "../../assets/Button_Disclosure_Down_Blue@3x.png";
import iconDisclosureDownDark from "../../assets/Button_Disclosure_Down_Blue_Dark@3x.png";
import iconDisclosureUp from "../../assets/Button_Disclosure_Up_Blue@3x.png";
import iconDisclosureUpDark from "../../assets/Button_Disclosure_Up_Blue_Dark@3x.png";
import iconTickboxInactive from "../../assets/Button_Tickbox_Inactive@3x.png";
import iconTickboxActive from "../../assets/Button_Tickbox_Active@3x.png";
import buttonCloseBlue from "../../assets/Button_Close_Blue@3x.png";

// CSS
import "../list/ListPage.css";
import "../../Shared.css";
import "../../../App.css";
import "../../css/Essentials.css";

// Controllers
import {
  IScreenProps,
  IUser,
  IGuideline,
  IGuidelineSummary,
  IClinicalNotice,
  ITrustPin,
  IPathway,
  IAlgorithm,
  IReferenceCard,
  IEssentialSection,
  IListFilterItem,
  IListType,
} from "../../Interfaces";
import AppController from "../../../controllers/AppController";
import DataController from "../../controllers/DataController";
import RemoteDataController from "../../controllers/RemoteDataController";

// Components
import AppHeader from "../../components/AppHeader";
import AppCard from "../../components/AppCard";
import GuidelineCell from "../../components/GuidelineCell";
import ClinicalNoticeCell from "../../components/ClinicalNoticeCell";
import SearchResultCell from "../../components/SearchResultCell";
import PathwayCell from "../../components/PathwayCell";
import EssentialsCell from "../../components/EssentialsCell";
import { Collapse } from "react-collapse";

type Props = RouteComponentProps<{ id: string; tab: string }> & {
  screenProps: IScreenProps;
  features: string[];
  listType: IListType;
};
type State = {
  selectedFilter: string;
  selectedFilters: IListFilterItem[];
  collapsedFilterGroups: string[];
  showFilter: boolean;
  showSearch: boolean;
  searchText: string;
  trustPinName: string | null;
};

class ListPage extends Component<Props, State> {
  private searchTextField: React.RefObject<HTMLIonInputElement>;

  constructor(props: Props) {
    super(props);

    this.searchTextField = React.createRef();

    this.state = {
      selectedFilter: "all",
      selectedFilters: [],
      collapsedFilterGroups: [],
      showFilter: false,
      showSearch: false,
      searchText: "",
      trustPinName: null,
    };
  }

  componentDidMount() {}

  componentDidUpdate(prevProps: Props, prevState: State) {}

  ionViewWillEnter() {
    if (this.props.location != null) {
      if (this.props.location.pathname.includes("/dashboard/pin")) {
        let trustPinName = this.props.location.pathname.split("/").pop();
        if (trustPinName != null) {
          trustPinName = decodeURIComponent(trustPinName);
          this.setState({ trustPinName });
        }
      }
    }

    // if (this.props.location.state != null) {
    //   let locationState: any = this.props.location.state;

    //   if (locationState.filter != null) {
    //     this.setState({ selectedFilter: locationState.filter });
    //   }
    // }
  }

  showFilter(shouldShow: boolean) {
    this.setState({ showFilter: shouldShow });
  }

  filterItemChanged(filterItem: IListFilterItem) {
    let selectedFilters = this.state.selectedFilters;
    let filterAdded = false;
    if (this.state.selectedFilters.some((item) => item.value === filterItem.value)) {
      selectedFilters = selectedFilters.filter((item) => item.value !== filterItem.value);
    } else {
      selectedFilters.push(filterItem);
      filterAdded = true;
    }

    this.setState({ selectedFilters });

    if (filterAdded) {
      RemoteDataController.logEvent("filter_changed", {
        filter_type: this.props.listType,
        filter_value: filterItem.group + " - " + filterItem.title,
      });
    }
  }

  resetFilterAndSearch() {
    this.setState({ selectedFilters: [], searchText: "", showSearch: false });
  }

  resetFilter() {
    this.setState({ selectedFilters: [] });
  }

  filterGroupCollapseButtonClicked(filterGroup: string) {
    let collapsedFilterGroups = this.state.collapsedFilterGroups;
    if (collapsedFilterGroups.includes(filterGroup)) {
      collapsedFilterGroups = collapsedFilterGroups.filter((f) => f !== filterGroup);
    } else {
      collapsedFilterGroups.push(filterGroup);
    }
    this.setState({ collapsedFilterGroups });
  }

  // filters out guideline summaries based on applied filters. Filters in the same group are 'OR', filters in different groups are 'AND'.
  filterGuidelineSummaries(guidelineSummaries: IGuidelineSummary[]) {
    let searchText = this.state.searchText.toLowerCase();
    let filterGroups = _.groupBy(this.state.selectedFilters, "group");

    let guidelineBookmarkGLIDs = this.props.screenProps.bookmarks
      .filter((bookmark) => bookmark.type === "guideline")
      .map((bookmark) => bookmark.GLID);

    let guidelineRecentlyViewedGLIDs = this.props.screenProps.recentlyViewed
      .filter((recentlyViewed) => recentlyViewed.type === "guideline")
      .map((recentlyViewed) => recentlyViewed.GLID);

    for (let filterGroup of Object.keys(filterGroups)) {
      let filters = filterGroups[filterGroup];
      let filterValues = filters.map((filter) => filter.value);
      let filterFunctions: Function[] = [];

      if (filterValues.includes("bookmarks")) {
        filterFunctions.push((guidelineSummary: IGuidelineSummary) => {
          return guidelineBookmarkGLIDs.includes(guidelineSummary.GLID);
        });
      }
      if (filterValues.includes("recentlyViewed")) {
        filterFunctions.push((guidelineSummary: IGuidelineSummary) => {
          return guidelineRecentlyViewedGLIDs.includes(guidelineSummary.GLID);
        });
      }

      if (filterGroup === "Categories") {
        for (let filterValue of filterValues) {
          filterFunctions.push((guidelineSummary: IGuidelineSummary) => {
            if (filterValue === "Section6") {
              return guidelineSummary.trust == null || guidelineSummary.trust === "";
            } else if (filterValue === "Standard Operating Procedures") {
              return guidelineSummary.GuidelineType === "Standard Operating Procedures";
            } else if (filterValue === "Other" && guidelineSummary.Section.includes("ALG")) {
              return true; // LAS algorithms has 2 guidelines included in algorithms (electrical injuries and head injuries)
            } else {
              return guidelineSummary.Section.includes(filterValue);
            }
          });
        }
      }

      if (filterGroup === "Guideline Type") {
        if (filterValues.includes("JRCALC")) {
          filterFunctions.push((guidelineSummary: IGuidelineSummary) => {
            return guidelineSummary.trust == null || guidelineSummary.trust === "";
          });
        }
        if (filterValues.includes("Trust")) {
          filterFunctions.push((guidelineSummary: IGuidelineSummary) => {
            return guidelineSummary.trust != null && guidelineSummary.trust !== "";
          });
        }
        if (filterValues.includes("Trust Guidance")) {
          filterFunctions.push((guidelineSummary: IGuidelineSummary) => {
            return guidelineSummary.annotations && guidelineSummary.annotations.length > 0;
          });
        }
        if (filterValues.includes("Clinical Guidelines")) {
          filterFunctions.push((guidelineSummary: IGuidelineSummary) => {
            return guidelineSummary.GuidelineType === "Clinical Guidelines";
          });
        }
        if (filterValues.includes("SOPs")) {
          filterFunctions.push((guidelineSummary: IGuidelineSummary) => {
            return guidelineSummary.GuidelineType === "Standard Operating Procedures";
          });
        }
        if (filterValues.includes("Shared Procedures")) {
          filterFunctions.push((guidelineSummary: IGuidelineSummary) => {
            return guidelineSummary.GuidelineType === "Shared Procedure";
          });
        }
        if (filterValues.includes("PGDs")) {
          filterFunctions.push((guidelineSummary: IGuidelineSummary) => {
            return guidelineSummary.GuidelineType === "Patient Group Direction";
          });
        }
        if (filterValues.includes("PMAs")) {
          filterFunctions.push((guidelineSummary: IGuidelineSummary) => {
            return guidelineSummary.GuidelineType === "Prescription Medicine Authorisation";
          });
        }
        if (filterValues.includes("Medicines Protocol")) {
          filterFunctions.push((guidelineSummary: IGuidelineSummary) => {
            return guidelineSummary.GuidelineType === "Medicines Protocol";
          });
        }
      }

      if (filterGroup === "Authorisation State") {
        filterFunctions.push((guidelineSummary: IGuidelineSummary) => {
          if (DataController.isAuthorisableGuideline(guidelineSummary)) {
            let pgdAck = this.props.screenProps.pgdAcks.find((aPgdAck) => aPgdAck.GLID === guidelineSummary.GLID);

            let pgdStatus = DataController.getPGDStatus(guidelineSummary, pgdAck, this.props.screenProps.pgdTrustInfo);

            if (filterValues.includes("Authorised") && pgdStatus === "Authorised") {
              return true;
            }
            if (
              filterValues.includes("Unauthorised") &&
              (pgdStatus === "UnauthorisedTakeQuiz" ||
                pgdStatus === "UnauthorisedAcknowledge" ||
                pgdStatus === "UnauthorisedQuizTaken")
            ) {
              return true;
            }
            if (filterValues.includes("Information Only") && pgdStatus === "InformationOnly") {
              return true;
            }
            if (filterValues.includes("No Authorisation") && pgdStatus === "NoAuth") {
              return true;
            }
          }
          return false;
        });
      }

      if (filterGroup === "Acknowledged State") {
        filterFunctions.push((guidelineSummary: IGuidelineSummary) => {
          if (guidelineSummary.SupportAcknowledment) {
            if (filterValues.includes("Acknowledged")) {
              if (this.props.screenProps.glAcks.find((aGLAck) => aGLAck.GLID === guidelineSummary.GLID)) {
                return true;
              }
            }
            if (filterValues.includes("Unacknowledged")) {
              if (this.props.screenProps.glAcks.find((aGLAck) => aGLAck.GLID === guidelineSummary.GLID) == null) {
                return true;
              }
            }
          }
          return false;
        });
      }

      if (filterGroup === "Staff Group") {
        filterFunctions.push((guidelineSummary: IGuidelineSummary) => {
          if (guidelineSummary.SG != null) {
            let guidelineStaffGroups = guidelineSummary.SG.replace(/, /g, ",").split(",");
            return _.intersection(filterValues, guidelineStaffGroups).length > 0;
          }
        });
      }

      // filter guideline summaries if matches any of the conditions in the filter group
      guidelineSummaries = guidelineSummaries.filter((guidelineSummary) =>
        filterFunctions.some((f) => f(guidelineSummary))
      );
    }

    // remove guidelines that don't match search
    if (searchText.length > 1) {
      guidelineSummaries = guidelineSummaries.filter((guidelineSummary) =>
        this.guidelineSummaryMatchesSearch(guidelineSummary)
      );
    }

    guidelineSummaries.sort((a, b) => {
      let aTitle = a.Title.toLowerCase();
      let bTitle = b.Title.toLowerCase();
      if (DataController.isPageForAge(a.GLID) && DataController.isPageForAge(b.GLID)) {
        if (a.GLID < b.GLID) {
          return -1;
        } else if (a.GLID > b.GLID) {
          return 1;
        }
      }
      if (aTitle < bTitle) {
        return -1;
      }
      if (aTitle > bTitle) {
        return 1;
      }
      return 0;
    });

    return guidelineSummaries;
  }

  filterAlgorithms(algorithms: IAlgorithm[]) {
    let searchText = this.state.searchText.toLowerCase();
    let filterGroups = _.groupBy(this.state.selectedFilters, "group");

    let algorithmBookmarkIDs = this.props.screenProps.bookmarks
      .filter((bookmark) => bookmark.type === "algorithm")
      .map((bookmark) => bookmark.algorithmID);

    let algorithmRecentlyViewedIDs = this.props.screenProps.recentlyViewed
      .filter((recentlyViewed) => recentlyViewed.type === "algorithm")
      .map((recentlyViewed) => recentlyViewed.algorithmID);

    // filter out algorithms not matching filters
    for (let filterGroup of Object.keys(filterGroups)) {
      let filters = filterGroups[filterGroup];
      let filterValues = filters.map((filter) => filter.value);
      let filterFunctions: Function[] = [];

      if (filterValues.includes("bookmarks")) {
        filterFunctions.push((algorithm: IAlgorithm) => {
          return algorithmBookmarkIDs.includes(algorithm.id);
        });
      }
      if (filterValues.includes("recentlyViewed")) {
        filterFunctions.push((algorithm: IAlgorithm) => {
          return algorithmRecentlyViewedIDs.includes(algorithm.id);
        });
      }

      if (filterGroup === "Categories") {
        for (let filterValue of filterValues) {
          filterFunctions.push((algorithm: IAlgorithm) => {
            if (algorithm.Section != null && algorithm.Section !== "") {
              return algorithm.Section.includes(filterValue);
            } else if (filterValue === "Other" && (algorithm.Section == null || algorithm.Section === "")) {
              return true;
            }
          });
        }
      }

      // filter algorithms if matches any of the conditions in the filter group
      algorithms = algorithms.filter((algorithm) => filterFunctions.some((f) => f(algorithm)));
    }

    // remove algorithms that don't match search
    if (searchText.length > 1) {
      algorithms = algorithms.filter((algorithm) => this.algorithmMatchesSearch(algorithm));
    }

    return algorithms;
  }

  filterClinicalNotices(clinicalNotices: IClinicalNotice[]) {
    let searchText = this.state.searchText.toLowerCase();
    let filterGroups = _.groupBy(this.state.selectedFilters, "group");

    let clinicalNoticeBookmarkIDs = this.props.screenProps.bookmarks
      .filter((bookmark) => bookmark.type === "clinical notice")
      .map((bookmark) => bookmark.clinicalNoticeID);

    let clinicalNoticeRecentlyViewedIDs = this.props.screenProps.recentlyViewed
      .filter((recentlyViewed) => recentlyViewed.type === "clinical notice")
      .map((recentlyViewed) => recentlyViewed.clinicalNoticeID);

    // filter out clinical notices not matching filters
    for (let filterGroup of Object.keys(filterGroups)) {
      let filters = filterGroups[filterGroup];
      let filterValues = filters.map((filter) => filter.value);
      let filterFunctions: Function[] = [];

      if (filterValues.includes("bookmarks")) {
        filterFunctions.push((clinicalNotice: IClinicalNotice) => {
          return clinicalNoticeBookmarkIDs.includes(clinicalNotice.ID);
        });
      }
      if (filterValues.includes("recentlyViewed")) {
        filterFunctions.push((clinicalNotice: IClinicalNotice) => {
          return clinicalNoticeRecentlyViewedIDs.includes(clinicalNotice.ID);
        });
      }

      if (filterGroup === "Acknowledged State") {
        filterFunctions.push((clinicalNotice: IClinicalNotice) => {
          let isCNAcknowledged = DataController.isCNAcknowledged(
            clinicalNotice,
            this.props.screenProps.clinicalNoticeAcks
          );
          if (filterValues.includes("Acknowledged") && isCNAcknowledged) {
            return true;
          }
          if (filterValues.includes("Unacknowledged") && isCNAcknowledged === false) {
            return true;
          }
          return false;
        });
      }

      // filter clinical notices if matches any of the conditions in the filter group
      clinicalNotices = clinicalNotices.filter((clinicalNotice) => filterFunctions.some((f) => f(clinicalNotice)));
    }

    // remove clinical notices that don't match search
    if (searchText.length > 1) {
      clinicalNotices = clinicalNotices.filter((clinicalNotice) => this.clinicalNoticeMatchesSearch(clinicalNotice));
    }

    return clinicalNotices;
  }

  filterPathways(pathways: IPathway[]) {
    let searchText = this.state.searchText.toLowerCase();
    let filterGroups = _.groupBy(this.state.selectedFilters, "group");

    let pathwayBookmarkIDs = this.props.screenProps.bookmarks
      .filter((bookmark) => bookmark.type === "pathway")
      .map((bookmark) => bookmark.pathwayID);

    let pathwayRecentlyViewedIDs = this.props.screenProps.recentlyViewed
      .filter((recentlyViewed) => recentlyViewed.type === "pathway")
      .map((recentlyViewed) => recentlyViewed.pathwayID);

    // filter out pathways not matching filters
    for (let filterGroup of Object.keys(filterGroups)) {
      let filters = filterGroups[filterGroup];
      let filterValues = filters.map((filter) => filter.value);
      let filterFunctions: Function[] = [];

      if (filterValues.includes("bookmarks")) {
        filterFunctions.push((pathway: IPathway) => {
          return pathwayBookmarkIDs.includes(pathway.id);
        });
      }
      if (filterValues.includes("recentlyViewed")) {
        filterFunctions.push((pathway: IPathway) => {
          return pathwayRecentlyViewedIDs.includes(pathway.id);
        });
      }

      // filter pathways if matches any of the conditions in the filter group
      pathways = pathways.filter((pathway) => filterFunctions.some((f) => f(pathway)));
    }

    // remove pathways that don't match search
    if (searchText.length > 1) {
      pathways = pathways.filter((pathway) => this.pathwayMatchesSearch(pathway));
    }

    return pathways;
  }

  filterEssentials(essentialSections: IEssentialSection[]) {
    let searchText = this.state.searchText.toLowerCase();
    let filterGroups = _.groupBy(this.state.selectedFilters, "group");

    let essentialsBookmarkIDs = this.props.screenProps.bookmarks
      .filter((bookmark) => bookmark.type === "essentials")
      .map((bookmark) => bookmark.GLID);

    // filter out essentials not matching filters
    for (let filterGroup of Object.keys(filterGroups)) {
      let filters = filterGroups[filterGroup];
      let filterValues = filters.map((filter) => filter.value);
      let filterFunctions: Function[] = [];

      if (filterValues.includes("bookmarks")) {
        filterFunctions.push((essentialSection: IEssentialSection) => {
          return essentialsBookmarkIDs.includes(essentialSection.id);
        });
      }

      // filter pathways if matches any of the conditions in the filter group
      essentialSections = essentialSections.filter((essentialSection) =>
        filterFunctions.some((f) => f(essentialSection))
      );
    }

    // remove essentials that don't match search
    if (searchText.length > 1) {
      essentialSections = essentialSections.filter((essentialSection) =>
        this.essentialSectionMatchesSearch(essentialSection)
      );
    }

    return essentialSections;
  }

  toggleSearch() {
    let shouldShow = !this.state.showSearch;

    this.setState({ showSearch: shouldShow, searchText: "" });
    if (shouldShow) {
      setTimeout(() => {
        this.searchTextField.current?.setFocus();
      }, 100);

      this.showFilter(false);
    }
  }

  searchTextChanged(event: any) {
    const value = event.target.value;

    this.setState({ searchText: value });
  }

  guidelineSummaryMatchesSearch(guidelineSummary: IGuidelineSummary) {
    let itemMatchesSearch = false;
    let searchText = this.state.searchText
      .toLowerCase()
      .replace(/\(/g, "\\(")
      .replace(/\)/g, "\\)")
      .replace(/\{/g, "\\{")
      .replace(/\}/g, "\\}")
      .replace(/\./g, "\\.")
      .replace(/\?/g, "\\?");

    if (this.props.listType === "PageForAge" && guidelineSummary.GLID === "P0050") {
      let test = "";
    }

    if (guidelineSummary.Title.toLowerCase().includes(searchText)) {
      itemMatchesSearch = true;
    } else if (guidelineSummary.SubTitle != null && guidelineSummary.SubTitle.toLowerCase().includes(searchText)) {
      itemMatchesSearch = true;
    } else if (guidelineSummary.GLID.toLowerCase().includes(searchText)) {
      itemMatchesSearch = true;
    } else {
      // check indexed words for search match
      if (guidelineSummary.IndexWords) {
        let indexedWords = guidelineSummary.IndexWords.match(/(?:[^\s']+|'[^']*')+/g);
        if (indexedWords) {
          for (let wordIndex = 0; wordIndex < indexedWords.length; wordIndex++) {
            let word = indexedWords[wordIndex];
            if (word.toLowerCase().includes(searchText)) {
              itemMatchesSearch = true;
              break;
            }
          }
        }
      }

      // check full text for search match
      if (!itemMatchesSearch) {
        let guidelineText = this.props.screenProps.getGuidelineText(guidelineSummary.GLID);
        if (guidelineText !== null && guidelineText !== undefined) {
          var re = new RegExp(searchText, "gi");
          if (re.exec(guidelineText) != null) {
            itemMatchesSearch = true;
          }
        }
      }
    }

    return itemMatchesSearch;
  }

  algorithmMatchesSearch(algorithm: IAlgorithm) {
    let itemMatchesSearch = false;
    let searchText = this.state.searchText.toLowerCase();

    if (
      algorithm.name.toLowerCase().includes(searchText) ||
      (algorithm.GLID != null && algorithm.GLID.toLowerCase().includes(searchText))
    ) {
      itemMatchesSearch = true;
    }

    return itemMatchesSearch;
  }

  clinicalNoticeMatchesSearch(clinicalNotice: IClinicalNotice) {
    let itemMatchesSearch = false;
    let searchText = this.state.searchText.toLowerCase();

    if (clinicalNotice.Title.toLowerCase().includes(searchText)) {
      itemMatchesSearch = true;
    }

    // match keywords
    if (clinicalNotice.Keywords && itemMatchesSearch === false) {
      let keywords = clinicalNotice.Keywords.split(",");
      if (keywords) {
        for (let wordIndex = 0; wordIndex < keywords.length; wordIndex++) {
          let word = keywords[wordIndex];
          if (word.toLowerCase().includes(searchText)) {
            itemMatchesSearch = true;
            break;
          }
        }
      }
    }

    if (itemMatchesSearch === false) {
      // check full text for search match
      if (!itemMatchesSearch) {
        let clinicalNoticeText = this.props.screenProps.getClinicalNoticeText(clinicalNotice.ID);
        if (clinicalNoticeText !== null && clinicalNoticeText !== undefined) {
          var re = new RegExp(searchText, "gi");
          if (re.exec(clinicalNoticeText) != null) {
            itemMatchesSearch = true;
          }
        }
      }
    }

    return itemMatchesSearch;
  }

  essentialSectionMatchesSearch(essentialSection: IEssentialSection) {
    let itemMatchesSearch = false;
    let searchText = this.state.searchText
      .toLowerCase()
      .replace(/\(/g, "\\(")
      .replace(/\)/g, "\\)")
      .replace(/\{/g, "\\{")
      .replace(/\}/g, "\\}")
      .replace(/\./g, "\\.");

    if (essentialSection.Name.toLowerCase().includes(searchText)) {
      itemMatchesSearch = true;
    } else {
      // check full text for search match
      if (!itemMatchesSearch) {
        let essentialSectionText = this.props.screenProps.getEssentialsText(essentialSection.id);

        const regex = new RegExp("\b" + searchText + "*", "gi");
        const result = [];

        if (essentialSectionText !== null && essentialSectionText !== undefined) {
          let match;
          var re = new RegExp(searchText, "gi");

          if (re.exec(essentialSectionText) != null) {
            itemMatchesSearch = true;
          }
        }
      }
    }

    return itemMatchesSearch;
  }

  pathwayMatchesSearch(pathway: IPathway) {
    let itemMatchesSearch = false;
    let searchText = this.state.searchText.toLowerCase();

    if (pathway.fields["Pathway name"] != null) {
      if (pathway.fields["Pathway name"].toLowerCase().includes(searchText)) {
        itemMatchesSearch = true;
      }
    }

    return itemMatchesSearch;
  }

  enterButtonClicked(event: any) {
    if (event.key === "Enter") {
    }
  }

  clearSearch() {
    this.searchTextField.current?.setFocus();
    this.setState({ searchText: "" });
  }

  cellClicked(GLID: string, type: "guideline" | "algorithm") {
    if (type === "guideline") {
      if (GLID != null) {
        let params: { [key: string]: any } | null = null;
        if (this.state.showSearch && this.state.searchText !== "") {
          params = { searchTerm: this.state.searchText };
        }

        if (this.state.trustPinName != null) {
          let trustPin = this.props.screenProps.trustPins.find((trustPin) => trustPin.name === this.state.trustPinName);

          let referenceCardForGuideline: IReferenceCard | null = null;

          if (trustPin != null) {
            if (trustPin.displayAsReferenceCard) {
              if (trustPin.referenceCards) {
                for (let referenceCard of trustPin.referenceCards) {
                  if (referenceCard.GLID === GLID) {
                    referenceCardForGuideline = referenceCard;
                  }
                }
              }

              if (params == null) {
                params = {
                  isReferenceCard: true,
                  referenceCard: referenceCardForGuideline,
                };
              } else {
                params.isReferenceCard = true;
                params.referenceCard = referenceCardForGuideline;
              }
            }
          }
        }

        this.props.screenProps.navigateToGuideline(
          GLID,
          this.props.match.params.tab,
          this.props.history,
          params,
          "List - " + this.props.listType
        );

        try {
          let guidelinesTabNavigationMethod = "scrolled";
          let filterActive = this.state.selectedFilters.length > 0;
          let searchActive = this.state.searchText.length > 1;
          if (filterActive && searchActive) {
            guidelinesTabNavigationMethod = "filtered and searched";
          } else if (filterActive) {
            guidelinesTabNavigationMethod = "filtered";
          } else if (searchActive) {
            guidelinesTabNavigationMethod = "searched";
          }

          let eventParams: any = {
            glid: this.props.screenProps.getGuidelineTitleForLogging(GLID),
            name: guidelinesTabNavigationMethod,
          };

          if (filterActive) {
            let filterNames = this.state.selectedFilters.map((item) => item.title);
            eventParams.filter_value = filterNames.join(", ");
          }

          RemoteDataController.logEvent("guideline_tab_navigation", eventParams);
        } catch (error) {
          console.log(error);
        }
      }
    } else {
      this.props.screenProps.navigateToAlgorithm(
        GLID,
        this.props.match.params.tab,
        this.props.history,
        "List - " + this.props.listType
      );
    }
  }

  clinicalNoticeCellClicked(clinicalNotice: IClinicalNotice) {
    let params: { [key: string]: any } | null = null;
    if (this.state.showSearch && this.state.searchText !== "") {
      params = { searchTerm: this.state.searchText };
    }

    this.props.screenProps.navigateToClinicalNotice(
      clinicalNotice.ID,
      this.props.match.params.tab,
      this.props.history,
      params,
      "List - " + this.props.listType
    );
  }

  pathwayCellClicked(pathway: IPathway) {
    this.props.screenProps.navigateToPathway(
      pathway,
      this.props.match.params.tab,
      this.props.history,
      "List - " + this.props.listType
    );
  }

  essentialsCellClicked(essentialSection: IEssentialSection) {
    this.props.screenProps.navigateToEssentialSection(
      essentialSection,
      this.props.match.params.tab,
      this.props.history,
      "List - " + this.props.listType
    );
  }

  getHiddenGuidelineSections() {
    return [
      "Section6",
      "FurtherResourcesOnly",
      "FurtherReourcesOnly",
      "ALG",
      "TimeCritical",
      "Covid-19",
      "Other",
      "General",
      "Alternative Destinations",
      "Care at Home Services",
      "Frail & Elderly Services",
      "NIAS",
    ];
  }

  getHiddenMedSections() {
    return [
      "Section1",
      "Section2",
      "Section3",
      "Section4",
      "Section5",
      "Section7",
      "FurtherResourcesOnly",
      "FurtherReourcesOnly",
      "ALG",
      "TimeCritical",
      "Covid-19",
      "Other",
      "General",
    ];
  }

  getGuidelineSections() {
    let sections = ["Section1", "Section2", "Section3", "Section4", "Section5", "Section7"];
    if (this.props.screenProps.app !== "iCPG") {
      sections.push("Shared Procedures");
    }

    if (this.props.features.includes("customTrustGuidelineSections")) {
      let otherSections: string[] = [];

      for (
        let guidelineSummaryIndex = 0;
        guidelineSummaryIndex < this.props.screenProps.guidelineSummaries.length;
        guidelineSummaryIndex++
      ) {
        let guidelineSummary = this.props.screenProps.guidelineSummaries[guidelineSummaryIndex];
        let guidelineSummarySections = guidelineSummary.Section.trim().split(", ");
        for (let guidelineSummarySection of guidelineSummarySections) {
          let trimmedGuidelineSummarySection = guidelineSummarySection.replace("FurtherResourcesOnly", "");
          trimmedGuidelineSummarySection = trimmedGuidelineSummarySection.replace("FurtherReourcesOnly", "");
          trimmedGuidelineSummarySection = trimmedGuidelineSummarySection.trim();

          if (
            trimmedGuidelineSummarySection !== "" &&
            sections.includes(trimmedGuidelineSummarySection) === false &&
            otherSections.includes(trimmedGuidelineSummarySection) === false
          ) {
            if (this.getHiddenGuidelineSections().includes(trimmedGuidelineSummarySection) === false) {
              if (
                DataController.isDrug(guidelineSummary) === false &&
                DataController.isAuthorisableGuideline(guidelineSummary) === false &&
                guidelineSummary.GuidelineType !== "Medicines Protocol" &&
                trimmedGuidelineSummarySection !== "Section8"
              ) {
                otherSections.push(trimmedGuidelineSummarySection);
              }
            }
          }
        }
      }

      otherSections.sort();

      sections = sections.concat(otherSections);

      sections.push("");
    } else {
      sections = ["Section1", "Section2", "Section3", "Section4", "Section5", "Section7"];
      if (this.props.screenProps.app !== "iCPG") {
        sections.push("Shared Procedures");
      }
      sections.push("");

      // sections = _.uniq(this.props.screenProps.guidelineSummaries.map((guidelineSummary) => guidelineSummary.Section));

      if (this.props.screenProps.trust === "YAS") {
        sections = [
          "Section1",
          "Section2",
          "Section3",
          "Section4",
          "Section5",
          "Section7",
          "Standard Operating Procedures",
          "",
        ];
      } else if (this.props.screenProps.trust === "EMAS" && this.props.screenProps.app === "Plus") {
        // sections = [
        //   "Airway",
        //   "Cardiac Care",
        //   "Clinical Handover",
        //   "Driving",
        //   "EPRF",
        //   "General",
        //   "Section1",
        //   "HART",
        //   "Manual Handling",
        //   "Section5",
        //   "Section3",
        //   "Mental Health and Capacity",
        //   "Patient Assessment and Treatment",
        //   "Paramedic Pathfinder Tools",
        //   "Section2",
        //   "Resuscitation",
        //   "Special Considerations",
        //   "Section7",
        //   "Specialist Paramedic",
        //   "Stroke",
        //   "Section4",
        //   "Trauma",
        //   "UCA",
        //   "Other",
        //   "",
        // ];
      }
    }

    let alternateSectionsNames: { [key: string]: string } = {
      Section1: "General Guidance",
      Section2: "Resuscitation",
      Section3: "Medical",
      Section4: "Trauma",
      Section5: "Maternity Care",
      Section6: "JRCALC Meds",
      Section7: "Special Situations",
    };

    if (this.props.features.includes("sortGuidelineSectionsAlphabetically")) {
      sections.sort((a, b) => {
        if (a === "") {
          return 1;
        } else if (b === "") {
          return -1;
        } else {
          let aSectionTitle = alternateSectionsNames[a] ?? a;
          let bSectionTitle = alternateSectionsNames[b] ?? b;

          return aSectionTitle.localeCompare(bSectionTitle);
        }
      });
    }

    return sections;
  }

  getMedSections() {
    let sections = ["Section6"];

    if (this.props.features.includes("customTrustMedSections")) {
      let otherSections: string[] = [];

      for (
        let guidelineSummaryIndex = 0;
        guidelineSummaryIndex < this.props.screenProps.guidelineSummaries.length;
        guidelineSummaryIndex++
      ) {
        let guidelineSummary = this.props.screenProps.guidelineSummaries[guidelineSummaryIndex];
        let guidelineSummarySections = guidelineSummary.Section.split(", ");
        for (let guidelineSummarySection of guidelineSummarySections) {
          let trimmedGuidelineSummarySection = guidelineSummarySection.trim();

          if (
            trimmedGuidelineSummarySection !== "" &&
            sections.includes(trimmedGuidelineSummarySection) === false &&
            otherSections.includes(trimmedGuidelineSummarySection) === false
          ) {
            // only add section if guidelineSummary is a drug
            if (
              DataController.isAuthorisableGuideline(guidelineSummary) ||
              guidelineSummary.GuidelineType === "Medicines Protocol"
            ) {
              if (this.getHiddenMedSections().includes(trimmedGuidelineSummarySection) === false) {
                otherSections.push(trimmedGuidelineSummarySection);
              }
            }
          }
        }
      }

      otherSections.sort();

      sections = sections.concat(otherSections);

      sections.push("");
    } else {
      sections = ["Section6"];
    }

    let alternateSectionsNames: { [key: string]: string } = {
      Section1: "General Guidance",
      Section2: "Resuscitation",
      Section3: "Medical",
      Section4: "Trauma",
      Section5: "Maternity Care",
      Section6: "JRCALC Meds",
      Section7: "Special Situations",
    };

    if (this.props.features.includes("sortMedSectionsAlphabetically")) {
      sections.sort((a, b) => {
        if (a === "") {
          return 1;
        } else if (b === "") {
          return -1;
        } else {
          let aSectionTitle = alternateSectionsNames[a] ?? a;
          let bSectionTitle = alternateSectionsNames[b] ?? b;

          return aSectionTitle.localeCompare(bSectionTitle);
        }
      });
    }

    return sections;
  }

  doesGuidelineBelongToSection2(guidelineSummary: IGuidelineSummary, section: string) {
    let belongsToSection = false;

    let trust = "";
    if (this.props.screenProps.user) {
      trust = this.props.screenProps.user?.trust;
    }

    let guidelineSummarySections = guidelineSummary.Section.trim().split(", ");
    if (guidelineSummarySections.includes(section)) {
      belongsToSection = true;
    }

    if (guidelineSummary.GLID === "EAST2620") {
      let test = "";
    }

    if (section === "Section1" && guidelineSummary.Section.includes("Section1")) {
      belongsToSection = true;
    } else if (section === "Section2" && guidelineSummary.Section.includes("Section2")) {
      belongsToSection = true;
    } else if (section === "Section3" && guidelineSummary.Section.includes("Section3")) {
      belongsToSection = true;
    } else if (section === "Section4" && guidelineSummary.Section.includes("Section4")) {
      belongsToSection = true;
    } else if (section === "Section5" && guidelineSummary.Section.includes("Section5")) {
      belongsToSection = true;
    } else if (section === "Section6" && guidelineSummary.trust) {
      return false;
    } else if (section === "Section6" && guidelineSummary.Section.includes("Section6")) {
      belongsToSection = true;
    } else if (section === "Section7" && guidelineSummary.Section.includes("Section7")) {
      belongsToSection = true;
    } else if (section === "Section6" && DataController.isAuthorisableGuideline(guidelineSummary)) {
      belongsToSection = true;
    } else if (section === "Section6" && guidelineSummary.GuidelineType === "Medicines Protocol") {
      belongsToSection = true;
    } else if (section === "" && guidelineSummary.Section.includes("Section") === false) {
      belongsToSection = true;
    } else if (section === "" && guidelineSummary.Section === "Section6" && guidelineSummary.trust) {
      belongsToSection = true;
    } else if (section === "" && guidelineSummary.Section === "") {
      belongsToSection = true;
    } else if (
      section === "Standard Operating Procedures" &&
      guidelineSummary.GuidelineType === "Standard Operating Procedures"
    ) {
      belongsToSection = true;
    } else if (section === "Shared Procedures" && guidelineSummary.GuidelineType === "Shared Procedure") {
      belongsToSection = true;
    } else if (section === guidelineSummary.Section) {
      belongsToSection = true;
    }

    return belongsToSection;
  }

  doesGuidelineBelongToSection(guidelineSummary: IGuidelineSummary, section: string) {
    let trust = "";
    if (this.props.screenProps.user) {
      trust = this.props.screenProps.user?.trust;
    }

    let searchText = this.state.searchText.toLowerCase();

    if (guidelineSummary.GLID === "SWT0590") {
      let test = "";
    }

    if (this.props.listType === "PageForAge") {
      if (DataController.isPageForAge(guidelineSummary.GLID)) {
        if (section === "Infants" && guidelineSummary.GLID <= "P0070") {
          return true;
        } else if (section === "Children" && guidelineSummary.GLID > "P0070") {
          return true;
        }
      } else {
        return false;
      }
    }

    if (
      guidelineSummary.Section.includes("FurtherReourcesOnly") ||
      guidelineSummary.Section.includes("FurtherResourcesOnly")
    ) {
      return false;
    }

    if (
      (this.props.listType === "Guidelines" && this.props.features.includes("customTrustGuidelineSections")) ||
      (this.props.listType === "Meds" && this.props.features.includes("customTrustMedSections"))
    ) {
      if (this.props.listType === "Meds") {
        if (
          DataController.isDrug(guidelineSummary) === false &&
          DataController.isAuthorisableGuideline(guidelineSummary) === false &&
          DataController.isPageForAge(guidelineSummary.GLID) === false &&
          (guidelineSummary.GuidelineType === "Medicines Protocol") === false
        ) {
          return false;
        }

        if (section === "Section6" && guidelineSummary.trust) {
          return false;
        }

        if (section === "" && guidelineSummary.trust == null) {
          return false;
        }

        if (DataController.isAuthorisableGuideline(guidelineSummary) && section === "Section6") {
          return true;
        } else if (guidelineSummary.GuidelineType === "Medicines Protocol" && section === "Section6") {
          return true;
        } else if (guidelineSummary.Section === "" && section === "") {
          return true;
        }
      }

      if (this.props.listType === "Guidelines") {
        if (
          (DataController.isDrug(guidelineSummary) && guidelineSummary.GLID !== "S0030") ||
          DataController.isAuthorisableGuideline(guidelineSummary) ||
          DataController.isPageForAge(guidelineSummary.GLID) ||
          guidelineSummary.GuidelineType === "Medicines Protocol"
        ) {
          return false;
        }
      }

      let guidelineSummarySections = guidelineSummary.Section.trim().split(", ");
      if (guidelineSummarySections.includes(section)) {
        return true;
      }

      if (guidelineSummary.Section.trim() === section) {
        return true;
      }

      if (section === "Shared Procedures" && DataController.isSharedProcedure(guidelineSummary)) {
        return true;
      }

      if (_.difference(guidelineSummarySections, this.getHiddenGuidelineSections()).length === 0) {
        // all guideline sections are hidden - so include in trust section
        if (section === "") {
          return true;
        }
      }
    } else {
      let isEMASPlus = trust === "EMAS" && this.props.screenProps.app === "Plus";
      isEMASPlus = false;

      let belongsToSection = false;

      if (guidelineSummary.Section === section) {
        belongsToSection = true;
      } else if (this.props.listType === "PGDs" && this.props.features.includes("groupPGDsBySection")) {
        if (section === "Section6") {
          belongsToSection = false;
        }
      } else if (guidelineSummary.Section.includes("Section1") && section === "Section1") {
        belongsToSection = true;
      } else if (guidelineSummary.Section.includes("Section2") && section === "Section2") {
        belongsToSection = true;
      } else if (guidelineSummary.Section.includes("Section3") && section === "Section3") {
        belongsToSection = true;
      } else if (guidelineSummary.Section.includes("Section4") && section === "Section4") {
        belongsToSection = true;
      } else if (guidelineSummary.Section.includes("Section5") && section === "Section5") {
        belongsToSection = true;
      } else if (guidelineSummary.Section.includes("Section6") && section === "Section6") {
        belongsToSection = true;
      } else if (DataController.isAuthorisableGuideline(guidelineSummary) && section === "Section6") {
        belongsToSection = true;
      } else if (guidelineSummary.GuidelineType === "Medicines Protocol" && section === "Section6") {
        belongsToSection = true;
      } else if (guidelineSummary.Section.includes("Section7") && section === "Section7") {
        belongsToSection = true;
      } else if (isEMASPlus === false && guidelineSummary.Section.includes("Section") === false && section === "") {
        belongsToSection = true;
      } else if (isEMASPlus === false && guidelineSummary.Section === "" && section === "") {
        belongsToSection = true;
      } else if (isEMASPlus && guidelineSummary.Section === "" && section === "") {
        belongsToSection = true;
      } else if (isEMASPlus && guidelineSummary.Section.includes(section) && section !== "") {
        // EMAS has own categories so include any guidelines whose section is included
        belongsToSection = true;
      } else if (
        guidelineSummary.GuidelineType === "Standard Operating Procedures" &&
        section === "Standard Operating Procedures"
      ) {
        belongsToSection = true;
      } else if (guidelineSummary.GuidelineType === "Shared Procedure" && section === "Shared Procedures") {
        belongsToSection = true;
      }

      return belongsToSection;
    }

    return false;
  }

  getMedStaffGroups() {
    let staffGroups: string[] = [];

    for (
      let guidelineSummaryIndex = 0;
      guidelineSummaryIndex < this.props.screenProps.guidelineSummaries.length;
      guidelineSummaryIndex++
    ) {
      let guidelineSummary = this.props.screenProps.guidelineSummaries[guidelineSummaryIndex];

      if (guidelineSummary.SG != null) {
        let guidelineStaffGroups = guidelineSummary.SG.replace(/, /g, ",").split(",");
        for (let guidelineStaffGroup of guidelineStaffGroups) {
          if (staffGroups.includes(guidelineStaffGroup) === false) {
            staffGroups.push(guidelineStaffGroup);
          }
        }
      }
    }

    staffGroups.sort();

    return staffGroups;
  }

  async canDismissFilterModal(data?: any, role?: string) {
    return role !== "gesture";
  }

  render() {
    let sectionsLayout = [];
    let resultsCount = 0;
    let listType = this.props.listType;
    let sectionNames: string[] = [];
    let sectionItems: {
      name: string;
      title: string;
      items: ReactElement[];
      sectionClass: string;
    }[] = [];
    let showSectionHeaders = true;
    let pageTitle = "";
    let searchText = this.state.searchText.toLowerCase();
    let searchPlaceholder = "Search";
    let isReferenceCardList = false;

    let trust = "";
    if (this.props.screenProps.user) {
      trust = this.props.screenProps.user?.trust;
    }

    let trustPin = this.props.screenProps.trustPins.find((trustPin) => trustPin.name === this.state.trustPinName);

    let guidelineBookmarkGLIDs = this.props.screenProps.bookmarks
      .filter((bookmark) => bookmark.type === "guideline")
      .map((bookmark) => bookmark.GLID);
    let guidelineRecentlyViewedGLIDs = this.props.screenProps.recentlyViewed
      .filter((recentlyViewed) => recentlyViewed.type === "guideline")
      .map((recentlyViewed) => recentlyViewed.GLID);
    let algorithmBookmarkIDs = this.props.screenProps.bookmarks
      .filter((bookmark) => bookmark.type === "algorithm")
      .map((bookmark) => bookmark.algorithmID);
    let algorithmRecentlyViewedIDs = this.props.screenProps.recentlyViewed
      .filter((recentlyViewed) => recentlyViewed.type === "algorithm")
      .map((recentlyViewed) => recentlyViewed.algorithmID);
    let clinicalNoticeBookmarkIDs = this.props.screenProps.bookmarks
      .filter((bookmark) => bookmark.type === "clinical notice")
      .map((bookmark) => bookmark.clinicalNoticeID);
    let clinicalNoticeRecentlyViewedIDs = this.props.screenProps.recentlyViewed
      .filter((recentlyViewed) => recentlyViewed.type === "clinical notice")
      .map((recentlyViewed) => recentlyViewed.clinicalNoticeID);
    let pathwayBookmarkIDs = this.props.screenProps.bookmarks
      .filter((bookmark) => bookmark.type === "pathway")
      .map((bookmark) => bookmark.pathwayID);
    let pathwayRecentlyViewedIDs = this.props.screenProps.recentlyViewed
      .filter((recentlyViewed) => recentlyViewed.type === "pathway")
      .map((recentlyViewed) => recentlyViewed.pathwayID);
    let essentialsBookmarkIDs = this.props.screenProps.bookmarks
      .filter((bookmark) => bookmark.type === "essentials")
      .map((bookmark) => bookmark.GLID);

    let guidelineSummaries = this.props.screenProps.guidelineSummaries;
    let algorithms = this.props.screenProps.algorithms;
    let clinicalNotices = this.props.screenProps.clinicalNotices;
    let pathways: IPathway[] = [];
    if (this.props.screenProps.pathwayData != null) {
      pathways = this.props.screenProps.pathwayData.Pathways;
    }
    let essentialSections = this.props.screenProps.essentialSections;

    // filter content based on list type
    // loop through guideline summaries and check if they belong in list
    guidelineSummaries = guidelineSummaries.filter((guidelineSummary) => {
      let isPageForAge = DataController.isPageForAge(guidelineSummary.GLID);
      let isDrug = DataController.isDrug(guidelineSummary);

      if (guidelineSummary.GLID === "SWT0590") {
        let test = "";
      }

      if (listType === "Guidelines" || listType === "Meds" || listType === "PageForAge") {
        if (listType === "Guidelines" && isDrug && guidelineSummary.GLID !== "S0030") {
          return false;
        }
        if (listType === "Guidelines" && isPageForAge) {
          return false;
        }

        if (
          guidelineSummary.Section.includes("FurtherReourcesOnly") ||
          guidelineSummary.Section.includes("FurtherResourcesOnly")
        ) {
          return false;
        }

        if (
          listType === "Meds" &&
          isDrug === false &&
          DataController.isAuthorisableGuideline(guidelineSummary) === false &&
          guidelineSummary.GuidelineType !== "Medicines Protocol"
        ) {
          return false;
        }

        if (listType === "Meds" && DataController.isPageForAge(guidelineSummary.GLID)) {
          return false;
        } else if (listType === "PageForAge" && DataController.isPageForAge(guidelineSummary.GLID) === false) {
          return false;
        } else if (
          listType === "Guidelines" &&
          (DataController.isAuthorisableGuideline(guidelineSummary) ||
            guidelineSummary.GuidelineType === "Medicines Protocol")
        ) {
          return false; // should appear in meds not guidelines
        } else if (
          listType === "Meds" &&
          guidelineSummary.Section === "" &&
          !DataController.isAuthorisableGuideline(guidelineSummary) &&
          guidelineSummary.GuidelineType !== "Medicines Protocol"
        ) {
          return false; // skip over PGDs, PMAs and SMGs that aren't drugs in MedsPage
        }

        // filter out GAUTH guideline
        if (guidelineSummary.GLID === "GAUTH") {
          return false;
        }
      } else if (listType === "Bookmarks") {
        if (!guidelineBookmarkGLIDs.includes(guidelineSummary.GLID)) {
          return false;
        }
      } else if (listType === "RecentlyViewed") {
        if (!guidelineRecentlyViewedGLIDs.includes(guidelineSummary.GLID)) {
          return false;
        }
      } else if (listType === "Covid19") {
        if (guidelineSummary.Section.includes("Covid-19") === false) {
          return false;
        }
      } else if (listType === "TimeCritical") {
        if (guidelineSummary.Section.includes("TimeCritical") === false) {
          return false;
        }
      } else if (listType === "SharedProcedures") {
        if (DataController.isSharedProcedure(guidelineSummary) === false) {
          return false;
        }
      } else if (listType === "PGDs") {
        if (DataController.isPGD(guidelineSummary) === false) {
          return false;
        }
      } else if (listType === "PMAs") {
        if (DataController.isPMA(guidelineSummary) === false) {
          return false;
        }
      } else if (listType === "SMGs") {
        if (DataController.isSMG(guidelineSummary) === false) {
          return false;
        }
      } else if (listType === "AcknowledgeableGuidelines") {
        if (guidelineSummary.SupportAcknowledment !== true) {
          return false;
        }
      } else if (listType === "TrustGuidelines") {
        if (guidelineSummary.trust == null) {
          return false;
        }
      } else if (listType === "ClinicalNotices" || listType === "LocalClinicalUpdates" || listType === "Essentials") {
        return false;
      }
      return true;
    });

    // loop through algorithms and check if they belong in list
    algorithms = algorithms.filter((algorithm) => {
      if (listType === "Bookmarks") {
        if (algorithmBookmarkIDs.includes(algorithm.id) === false) {
          return false;
        }
      } else if (listType === "RecentlyViewed") {
        if (algorithmRecentlyViewedIDs.includes(algorithm.id) === false) {
          return false;
        }
      }
      return true;
    });

    // loop through clinical notices and check if they belong in list
    clinicalNotices = clinicalNotices.filter((clinicalNotice) => {
      if (listType === "ClinicalNotices") {
        if (this.props.features.includes("localClinicalUpdates") && clinicalNotice.localClinicalUpdate === true) {
          return false;
        }
      } else if (listType === "LocalClinicalUpdates") {
        if (clinicalNotice.localClinicalUpdate !== true) {
          return false;
        }
      } else if (listType === "Bookmarks") {
        if (clinicalNoticeBookmarkIDs.includes(clinicalNotice.ID) === false) {
          return false;
        }
      } else if (listType === "RecentlyViewed") {
        if (clinicalNoticeRecentlyViewedIDs.includes(clinicalNotice.ID) === false) {
          return false;
        }
      } else if (listType === "Covid19") {
        if (
          clinicalNotice.Title.toLowerCase().includes("covid") === false &&
          clinicalNotice.Title.toLowerCase().includes("coronavirus") === false
        ) {
          return false;
        }
      }
      return true;
    });

    // loop through pathways and check if they belong in list
    pathways = pathways.filter((pathway) => {
      if (listType === "Bookmarks") {
        if (pathwayBookmarkIDs.includes(pathway.id) === false) {
          return false;
        }
      } else if (listType === "RecentlyViewed") {
        if (pathwayRecentlyViewedIDs.includes(pathway.id) === false) {
          return false;
        }
      }
      return true;
    });

    // loop through essentials and check if they belong in list
    essentialSections = essentialSections.filter((essentialSection) => {
      if (this.props.screenProps.app !== "CFR") {
        return false;
      }
      if (listType === "Bookmarks") {
        if (essentialsBookmarkIDs.includes(essentialSection.id) === false) {
          return false;
        }
      }
      return true;
    });

    // filter content based on selected filters and search
    guidelineSummaries = this.filterGuidelineSummaries(guidelineSummaries);
    algorithms = this.filterAlgorithms(algorithms);
    clinicalNotices = this.filterClinicalNotices(clinicalNotices);
    pathways = this.filterPathways(pathways);
    essentialSections = this.filterEssentials(essentialSections);

    // build list of sections
    if (listType === "Guidelines") {
      sectionNames = this.getGuidelineSections();
      // sectionNames = ["A-Z"];
      pageTitle = "Guidelines";
      searchPlaceholder = "Search Guidelines";
    } else if (listType === "Meds") {
      sectionNames = this.getMedSections();
      if (this.props.features.includes("customTrustMedSections")) {
        showSectionHeaders = true;
      } else {
        showSectionHeaders = false;
      }
      pageTitle = "Meds";
      searchPlaceholder = "Search Meds";
    } else if (listType === "Algorithms") {
      let nonUniqueSections = this.props.screenProps.algorithms.map((algorithm) => algorithm.Section);
      nonUniqueSections.push("Other");

      sectionNames = _.uniq(nonUniqueSections);
      sectionNames.sort();
      pageTitle = "Algorithms";
      searchPlaceholder = "Search Algorithms";
    } else if (listType === "PageForAge") {
      sectionNames = ["Infants", "Children"];
      showSectionHeaders = true;
      pageTitle = "Page for Age";
      searchPlaceholder = "Search Page for Age";
    } else if (listType === "Bookmarks") {
      sectionNames = ["Guidelines", "Meds", "Algorithms", "Page for Age", "Clinical Notices", "Pathways", "Essentials"];
      pageTitle = "Bookmarks";
      searchPlaceholder = "Search Bookmarks";
    } else if (listType === "RecentlyViewed") {
      sectionNames = ["Guidelines", "Meds", "Page for Age", "Algorithms", "Clinical Notices", "Pathways", "Essentials"];
      pageTitle = "Recently Viewed";
      searchPlaceholder = "Search Recently Viewed";
    } else if (listType === "ClinicalNotices") {
      sectionNames = ["unacknowledged", "acknowledged"];
      pageTitle = "Clinical Notices";
      searchPlaceholder = "Search Clinical Notices";
    } else if (listType === "LocalClinicalUpdates") {
      sectionNames = ["acknowledged"];
      showSectionHeaders = false;
      pageTitle = "Local Clinical Updates";
      searchPlaceholder = "Search Local Clinical Updates";
    } else if (listType === "Covid19") {
      sectionNames = ["COVID-19"];
      pageTitle = "COVID-19";
      showSectionHeaders = false;
    } else if (listType === "SharedProcedures") {
      sectionNames = ["SharedProcedures"];
      pageTitle = "Shared Procedures";
      showSectionHeaders = false;
    } else if (listType === "AcknowledgeableGuidelines") {
      sectionNames = ["Unacknowledged", "Acknowledged"];
      pageTitle = `${DataController.getTrustDisplayName(trust)} Acknowledgeable Guidelines`;
      searchPlaceholder = "Search Guidelines";
    } else if (listType === "TimeCritical") {
      sectionNames = ["Time Critical"];
      pageTitle = "Time Critical";
      showSectionHeaders = false;
    } else if (listType === "PGDs") {
      sectionNames = ["Unauthorised", "No Authorisation", "Authorised", "Information Only"];
      if (this.props.features.includes("groupPGDsBySection")) {
        sectionNames = this.getMedSections();
      }
      // sectionNames = ["A-Z"];
      pageTitle = "PGDs";
      searchPlaceholder = "Search PGDs";
    } else if (listType === "PMAs") {
      sectionNames = ["Unauthorised", "No Authorisation", "Authorised", "Information Only"];
      pageTitle = "Prescription Medicine Authorisations";
      searchPlaceholder = "Search PMAs";
    } else if (listType === "SMGs") {
      sectionNames = ["Unauthorised", "No Authorisation", "Authorised", "Information Only"];
      pageTitle = "Supplementary Medication Guidelines";
      if (trust === "EMAS") {
        pageTitle = "Medication Supply Guidelines";
      }
      searchPlaceholder = "Search";
    } else if (listType === "TrustPin") {
      let trustPin = this.props.screenProps.trustPins.find((trustPin) => trustPin.name === this.state.trustPinName);

      if (trustPin != null) {
        sectionNames = [];

        if (trustPin != null) {
          if (trustPin.guidelines.length > 0) {
            sectionNames.push("Guidelines");
          }

          if (trustPin.guidelinesInSections && trustPin.guidelinesInSections.length > 0) {
            for (let guidelineSection of trustPin.guidelinesInSections) {
              try {
                let sectionTitle = guidelineSection.split("_")[1];
                if (sectionNames.includes(sectionTitle) === false) {
                  sectionNames.push(sectionTitle);
                }
              } catch (error) {}
            }
          }

          if (trustPin.algorithms.length > 0) {
            sectionNames.push("Algorithms");
          }

          if (trustPin.algorithmsInSections && trustPin.algorithmsInSections.length > 0) {
            for (let algorithmSection of trustPin.algorithmsInSections) {
              try {
                let sectionTitle = algorithmSection.split("_")[1];
                if (sectionNames.includes(sectionTitle) === false) {
                  sectionNames.push(sectionTitle);
                }
              } catch (error) {}
            }
          }

          if (trustPin.clinicalNotices.length > 0) {
            sectionNames.push("Clinical Notices");
          }

          if (trustPin.clinicalNoticesInSections && trustPin.clinicalNoticesInSections.length > 0) {
            for (let clinicalNoticeSection of trustPin.clinicalNoticesInSections) {
              try {
                let sectionTitle = clinicalNoticeSection.split("_")[1];
                if (sectionNames.includes(sectionTitle) === false) {
                  sectionNames.push(sectionTitle);
                }
              } catch (error) {}
            }
          }

          pageTitle = trustPin.name;
          searchPlaceholder = "Search";

          if (trustPin.displayAsReferenceCard) {
            isReferenceCardList = true;
          }
        }
      }
    } else if (listType === "TrustGuidelines") {
      let title = "Trust Guidelines";

      if (trust !== "") {
        title = DataController.getTrustDisplayName(trust) + " Guidelines";
      }

      sectionNames = ["Guidelines", "Meds"];
      pageTitle = title;
      searchPlaceholder = "Search " + title;
    } else if (listType === "Essentials") {
      for (let essentialSection of essentialSections) {
        if (essentialSection.Chapter === "Contents") {
          continue;
        } else if (essentialSection.Chapter.includes("Chapter")) {
          if (sectionNames.includes(essentialSection.Chapter) === false) {
            sectionNames.push(essentialSection.Chapter);
          }
        }
      }

      sectionNames.push("End Matter");

      pageTitle = "Essentials";
      searchPlaceholder = "Search Essentials";
    }

    // add a title matches section to each list
    sectionNames.unshift("Title Matches");

    /**
     *
     * Start of new sections layout
     *
     */

    // configure each section
    for (let sectionIndex = 0; sectionIndex < sectionNames.length; sectionIndex++) {
      let sectionName = sectionNames[sectionIndex];
      let sectionTitle = DataController.getSectionTitle(sectionName);
      let sectionClass = DataController.getSectionClass(sectionName);
      if (sectionName === "" && this.props.screenProps.trust !== "") {
        sectionTitle = DataController.getTrustDisplayName(this.props.screenProps.trust);
        sectionClass = DataController.getSectionClass(trust);
      }

      if (listType === "Guidelines" || listType === "Meds" || listType === "PageForAge") {
        if (
          sectionName === "Section1" ||
          sectionName === "Section2" ||
          sectionName === "Section3" ||
          sectionName === "Section4" ||
          sectionName === "Section5" ||
          sectionName === "Section6" ||
          sectionName === "Section7" ||
          sectionName === "Page for Age" ||
          sectionName === "Shared Procedures"
        ) {
          sectionClass = DataController.getSectionClass(sectionName);
        } else {
          sectionClass = DataController.getSectionClass(trust);
        }

        if (listType === "PageForAge") {
          sectionClass = DataController.getSectionClass("Page for Age");
        }

        if (sectionName === "" && this.props.screenProps.trust) {
          sectionTitle = DataController.getTrustDisplayName(this.props.screenProps.trust);
          sectionClass = this.props.screenProps.trust;
        }

        // if (trust === "EMAS") {
        //   if (sectionName === "Driving") {
        //     sectionTitle = "Driving and Vehicle Transport Information";
        //   } else if (sectionName === "EPRF") {
        //     sectionTitle = "EPR";
        //   } else if (sectionName === "HART") {
        //     sectionTitle = "HART and Major Incident";
        //   } else if (sectionName === "Paramedic Pathfinder Tools") {
        //     sectionTitle = "Pathfinder Tools";
        //   } else if (sectionName === "Resuscitation") {
        //     sectionTitle = "Resuscitation - EMAS";
        //     sectionClass = DataController.getSectionClass(""); // done so doesn't use turquoise resuscitation color
        //   } else if (sectionName === "Trauma") {
        //     sectionTitle = "Trauma - EMAS";
        //     sectionClass = DataController.getSectionClass(""); // done so doesn't use red trauma color
        //   } else if (sectionName === "Specialist Paramedic") {
        //     sectionTitle = "Specialist Practitioner";
        //   }
        // }
      }

      if (listType === "Algorithms") {
        if (sectionName === "" && this.props.screenProps.trust) {
          sectionTitle = DataController.getTrustDisplayName(this.props.screenProps.trust);
          sectionClass = this.props.screenProps.trust;
        }
      }

      if (listType === "ClinicalNotices") {
        if (sectionName === "unacknowledged") {
          sectionTitle = "Unacknowledged";
          sectionClass = DataController.getSectionClass("unacknowledged");
        } else if (sectionName === "acknowledged") {
          sectionTitle = "Acknowledged";
          sectionClass = DataController.getSectionClass("acknowledged");
        }
      }

      if (listType === "PGDs" || listType === "PMAs" || listType === "SMGs") {
        if (sectionName === "Authorised") {
          sectionClass = DataController.getSectionClass("acknowledged");
        } else if (sectionName === "Information Only" || sectionName === "No Authorisation") {
          sectionClass = DataController.getSectionClass("info-only");
        } else if (sectionName === "Unauthorised") {
          sectionClass = DataController.getSectionClass("unacknowledged");
        } else {
          sectionClass = DataController.getSectionClass(trust);
        }
      }

      if (listType === "Essentials") {
        sectionClass = "essentials";
      }

      sectionItems.push({
        name: sectionName,
        title: sectionTitle,
        items: [],
        sectionClass: sectionClass,
      });
    }

    // for (let sectionIndex = 0; sectionIndex < sectionNames.length; sectionIndex++) {
    //   let sectionName = sectionNames[sectionIndex];
    //   let sectionTitle = "";
    //   let sectionClass = "";

    //   if (listType === "Guidelines" || listType === "Meds" || listType === "PageForAge") {
    //     sectionTitle = sectionName;

    //     if (
    //       sectionName === "Section1" ||
    //       sectionName === "Section2" ||
    //       sectionName === "Section3" ||
    //       sectionName === "Section4" ||
    //       sectionName === "Section5" ||
    //       sectionName === "Section6" ||
    //       sectionName === "Section7" ||
    //       sectionName === "Page for Age" ||
    //       sectionName === "Shared Procedures"
    //     ) {
    //       sectionClass = DataController.getSectionClass(sectionName);
    //     } else {
    //       sectionClass = DataController.getSectionClass(trust);
    //     }

    //     if (listType === "PageForAge") {
    //       sectionClass = DataController.getSectionClass("Page for Age");
    //     }

    //     if (sectionName === "" && this.props.screenProps.trust) {
    //       sectionTitle = DataController.getTrustDisplayName(this.props.screenProps.trust);
    //       sectionClass = this.props.screenProps.trust;
    //     } else if (sectionName != null && sectionName !== "") {
    //       sectionTitle = DataController.getSectionTitle(sectionName);
    //       // sectionTitle = sectionTitle + " (" + section + ")";
    //     }

    //     if (trust === "EMAS") {
    //       if (sectionName === "Driving") {
    //         sectionTitle = "Driving and Vehicle Transport Information";
    //       } else if (sectionName === "EPRF") {
    //         sectionTitle = "EPR";
    //       } else if (sectionName === "HART") {
    //         sectionTitle = "HART and Major Incident";
    //       } else if (sectionName === "Paramedic Pathfinder Tools") {
    //         sectionTitle = "Pathfinder Tools";
    //       } else if (sectionName === "Resuscitation") {
    //         sectionTitle = "Resuscitation - EMAS";
    //         sectionClass = DataController.getSectionClass(""); // done so doesn't use turquoise resuscitation color
    //       } else if (sectionName === "Trauma") {
    //         sectionTitle = "Trauma - EMAS";
    //         sectionClass = DataController.getSectionClass(""); // done so doesn't use red trauma color
    //       } else if (sectionName === "Specialist Paramedic") {
    //         sectionTitle = "Specialist Practitioner";
    //       }
    //     }
    //   }

    //   if (listType === "Algorithms") {
    //     sectionTitle = sectionName;
    //     sectionClass = DataController.getSectionClass(sectionName);

    //     if (sectionName === "" && this.props.screenProps.trust) {
    //       sectionTitle = DataController.getTrustDisplayName(this.props.screenProps.trust);
    //       sectionClass = this.props.screenProps.trust;
    //     } else if (sectionName != null && sectionName !== "") {
    //       sectionTitle = DataController.getSectionTitle(sectionName);
    //     }
    //   }

    //   if (listType === "ClinicalNotices") {
    //     if (sectionName === "unacknowledged") {
    //       sectionTitle = "Unacknowledged";
    //       sectionClass = DataController.getSectionClass("unacknowledged");
    //     } else if (sectionName === "acknowledged") {
    //       sectionTitle = "Acknowledged";
    //       sectionClass = DataController.getSectionClass("acknowledged");
    //     }
    //   }

    //   if (listType === "LocalClinicalUpdates") {
    //     sectionTitle = sectionName;
    //     sectionClass = DataController.getSectionClass(sectionName);
    //   }

    //   if (listType === "Bookmarks") {
    //     sectionTitle = sectionName;
    //     sectionClass = DataController.getSectionClass(sectionName);
    //   }

    //   if (listType === "RecentlyViewed") {
    //     sectionTitle = sectionName;
    //     sectionClass = DataController.getSectionClass(sectionName);
    //   }

    //   if (listType === "Covid19") {
    //     sectionTitle = sectionName;
    //     sectionClass = DataController.getSectionClass(sectionName);
    //   }

    //   if (listType === "AcknowledgeableGuidelines") {
    //     sectionTitle = sectionName;
    //     sectionClass = DataController.getSectionClass(sectionName);
    //   }

    //   if (listType === "TimeCritical") {
    //     sectionTitle = sectionName;
    //     sectionClass = DataController.getSectionClass(sectionName);
    //   }

    //   if (listType === "PGDs" || listType === "PMAs" || listType === "SMGs") {
    //     sectionTitle = sectionName;

    //     if (sectionName === "Authorised") {
    //       sectionClass = DataController.getSectionClass("acknowledged");
    //     } else if (sectionName === "Information Only" || sectionName === "No Authorisation") {
    //       sectionClass = DataController.getSectionClass("info-only");
    //     } else if (sectionName === "Unauthorised") {
    //       sectionClass = DataController.getSectionClass("unacknowledged");
    //     } else {
    //       sectionClass = DataController.getSectionClass(sectionName);
    //     }
    //   }

    //   if (listType === "TrustPin") {
    //     sectionTitle = DataController.getSectionTitle(sectionName);
    //     sectionClass = DataController.getSectionClass(sectionName);
    //   }

    //   if (listType === "TrustGuidelines") {
    //     sectionTitle = sectionName;
    //     sectionClass = DataController.getSectionClass(sectionName);
    //   }

    //   if (listType === "Essentials") {
    //     sectionTitle = sectionName;
    //     sectionClass = "essentials";
    //   }

    //   if (sectionName === "Title Matches") {
    //     sectionTitle = "Title Matches";
    //     sectionClass = DataController.getSectionClass("Title Matches");
    //   }

    //   sectionItems.push({
    //     name: sectionName,
    //     title: sectionTitle,
    //     items: [],
    //     sectionClass: sectionClass,
    //   });
    // }

    let titleMatchSection = sectionItems.find((section) => section.name === "Title Matches");

    // loop through guideline summaries and check if they belong to the section
    for (let guidelineIndex = 0; guidelineIndex < guidelineSummaries.length; guidelineIndex++) {
      let guidelineSummary = guidelineSummaries[guidelineIndex];

      let isPageForAge = DataController.isPageForAge(guidelineSummary.GLID);
      let isDrug = DataController.isDrug(guidelineSummary);

      let pgdAck = null;
      if (DataController.isAuthorisableGuideline(guidelineSummary)) {
        pgdAck = this.props.screenProps.pgdAcks.find((aPgdAck) => aPgdAck.GLID === guidelineSummary.GLID);
      }

      let glAck = null;
      if (guidelineSummary.SupportAcknowledment === true) {
        glAck = this.props.screenProps.glAcks.find((aGLAck) => aGLAck.GLID === guidelineSummary.GLID);
      }

      let updated = this.props.screenProps.isGuidelineUpdated(guidelineSummary);

      let columnSize = "1";
      let imageName = null;

      if (guidelineSummary.GLID === "SWT0590") {
        let test = "";
      }

      for (let sectionIndex = 0; sectionIndex < sectionItems.length; sectionIndex++) {
        let section = sectionItems[sectionIndex];

        if (section.name === "Title Matches") {
          continue;
        }

        // check if guideline summary belongs to section
        if (section.name === "A-Z") {
          // include all items
        } else if (listType === "Guidelines" || listType === "Meds" || listType === "PageForAge") {
          let belongsToSection = this.doesGuidelineBelongToSection(guidelineSummary, section.name);
          if (belongsToSection === false) {
            continue;
          }
        } else if (listType === "Algorithms") {
          if (section.name !== "Other" || guidelineSummary.Section.includes("ALG") === false) {
            continue;
          }
        } else if (listType === "Bookmarks") {
          if (section.name !== "Guidelines" && section.name !== "Meds" && section.name !== "Page for Age") {
            continue;
          } else if (section.name === "Guidelines" && (isPageForAge || isDrug)) {
            continue; // don't show page for age or meds
          } else if (section.name === "Meds" && (!isDrug || isPageForAge)) {
            continue;
          } else if (section.name === "Page for Age" && !isPageForAge) {
            continue;
          }
        } else if (listType === "RecentlyViewed") {
          if (section.name !== "Guidelines" && section.name !== "Meds" && section.name !== "Page for Age") {
            continue;
          } else if (section.name === "Guidelines" && (isPageForAge || isDrug)) {
            continue; // don't show page for age or meds
          } else if (section.name === "Meds" && (!isDrug || isPageForAge)) {
            continue;
          } else if (section.name === "Page for Age" && !isPageForAge) {
            continue;
          }
        } else if (listType === "PGDs" || listType === "PMAs" || listType === "SMGs") {
          if (section.name === "Information Only" && !guidelineSummary.informationOnly) {
            continue;
          }

          let pgdStatus = DataController.getPGDStatus(guidelineSummary, pgdAck, this.props.screenProps.pgdTrustInfo);

          if (section.name === "Authorised" && pgdStatus !== "Authorised") {
            continue;
          }

          if (
            section.name === "Unauthorised" &&
            pgdStatus !== "UnauthorisedAcknowledge" &&
            pgdStatus !== "UnauthorisedQuizTaken" &&
            pgdStatus !== "UnauthorisedTakeQuiz"
          ) {
            continue;
          }

          if (section.name === "No Authorisation" && pgdStatus !== "NoAuth") {
            continue;
          }

          if (["Unauthorised", "Authorised", "Information Only", "No Authorisation"].includes(section.name) === false) {
            let belongsToSection = this.doesGuidelineBelongToSection2(guidelineSummary, section.name);
            if (belongsToSection === false) {
              continue;
            }
          }
        } else if (listType === "AcknowledgeableGuidelines") {
          if (section.name === "Unacknowledged" && glAck != null) {
            continue;
          } else if (section.name === "Acknowledged" && glAck == null) {
            continue;
          }
        } else if (listType === "TrustPin") {
          let isMatchingGuideline = false;

          if (trustPin != null) {
            let isCustomSection =
              section.name !== "Guidelines" && section.name !== "Clinical Notices" && section.name !== "Algorithms";

            if (section.name === "Guidelines" || isCustomSection) {
              if (isCustomSection) {
                if (
                  trustPin.guidelinesInSections &&
                  trustPin.guidelinesInSections.includes(guidelineSummary.GLID + "_" + section.name)
                ) {
                  isMatchingGuideline = true;
                }
              } else {
                isMatchingGuideline = trustPin.guidelines.includes(guidelineSummary.GLID);
              }

              if (isMatchingGuideline) {
                // if reference card - get image for cell
                if (isReferenceCardList && guidelineSummary.images && guidelineSummary.images.length > 0) {
                  let referenceCardImageName: string | null = null;

                  if (trustPin != null && trustPin.displayAsReferenceCard && trustPin.referenceCards) {
                    for (let referenceCard of trustPin.referenceCards) {
                      if (referenceCard.GLID === guidelineSummary.GLID) {
                        if (referenceCard.imageNames && referenceCard.imageNames.length > 0) {
                          referenceCardImageName = referenceCard.imageNames[0];
                        } else if (referenceCard.imageName) {
                          referenceCardImageName = referenceCard.imageName;
                        }
                      }
                    }
                  }

                  if (referenceCardImageName != null && referenceCardImageName !== "") {
                    for (let image of guidelineSummary.images) {
                      if (image.imageName === referenceCardImageName) {
                        imageName = image.imageName;
                        break;
                      }
                    }
                  }

                  // fallback if no reference card image specified - use first image
                  if (imageName == null) {
                    imageName = guidelineSummary.images[0].imageName;
                  }

                  // get image path if possible
                  try {
                    // try bundled image path first
                    imageName = DataController.getBundledImageData({
                      imageName: imageName,
                      trust: guidelineSummary.trust,
                    });
                  } catch (error) {
                    // if can't load bundled image data, try downloaded image
                    if (
                      _.findIndex(this.props.screenProps.images, (_image: any) =>
                        _image.name.includes(guidelineSummary.GLID)
                      ) !== -1
                    ) {
                      let images = this.props.screenProps.images.filter((_image: any) =>
                        _image.name.includes(guidelineSummary.GLID)
                      );

                      for (let i = 0; i < images.length; i++) {
                        let image = images[i];
                        if (image.name === imageName) {
                          imageName = image.data;
                        }
                      }
                    }
                  }
                }

                // double size so can fit image
                if (isReferenceCardList) {
                  columnSize = "2";
                }
              }
            }
          }

          if (isMatchingGuideline === false) {
            continue;
          }
        } else if (listType === "TrustGuidelines") {
          if (section.name === "Guidelines" || section.name === "Meds") {
            if (section.name === "Guidelines" && isDrug) {
              continue; // don't show page for age or meds
            } else if (section.name === "Meds" && !isDrug) {
              continue;
            }
          } else {
            continue;
          }
        } else {
          // continue;
        }

        if (guidelineSummary.GLID === "S0020") {
          let test = "";
        }

        // @ts-ignore
        if (guidelineSummary.caption != null) {
          continue;
        }

        // guideline is not an algorithm
        let guidelineCell = (
          <IonCol size={columnSize} key={section.name + guidelineSummary.GLID + guidelineSummary.Title}>
            <GuidelineCell
              guidelineSummary={guidelineSummary}
              referenceCardImageName={imageName}
              userTrust={trust}
              pgdAck={pgdAck}
              glAck={glAck}
              searchText={this.state.searchText}
              bookmarked={guidelineBookmarkGLIDs.includes(guidelineSummary.GLID)}
              updated={updated}
              inAlgorithmList={listType === "Algorithms"}
              cellClicked={this.cellClicked.bind(this)}
              screenProps={this.props.screenProps}
            />
          </IonCol>
        );

        section.items.push(guidelineCell);
        if (
          titleMatchSection != null &&
          searchText.length > 1 &&
          guidelineSummary.Title.toLowerCase().includes(searchText)
        ) {
          titleMatchSection.items.push(guidelineCell);
        }
      }
    }

    for (let algorithmIndex = 0; algorithmIndex < algorithms.length; algorithmIndex++) {
      let algorithm = algorithms[algorithmIndex];

      let columnSize = "1";
      let imageName = null;

      for (let sectionIndex = 0; sectionIndex < sectionItems.length; sectionIndex++) {
        let section = sectionItems[sectionIndex];

        if (section.name === "Title Matches") {
          continue;
        }

        // check if algorithm belongs to section
        if (listType === "Algorithms") {
          if (algorithm.Section !== section.name) {
            continue;
          }
        } else if (listType === "Bookmarks") {
          if (section.name !== "Algorithms") {
            continue;
          }
        } else if (listType === "RecentlyViewed") {
          if (section.name !== "Algorithms") {
            continue;
          }
        } else if (listType === "TrustPin") {
          let isMatchingAlgorithm = false;

          if (trustPin != null) {
            let isCustomSection =
              section.name !== "Guidelines" && section.name !== "Clinical Notices" && section.name !== "Algorithms";

            if (section.name === "Algorithms" || isCustomSection) {
              if (isCustomSection) {
                if (
                  trustPin.algorithmsInSections &&
                  trustPin.algorithmsInSections.includes(algorithm.id + "_" + section.name)
                ) {
                  isMatchingAlgorithm = true;
                }
              } else {
                isMatchingAlgorithm = trustPin.algorithms.includes(algorithm.id);
              }

              if (isMatchingAlgorithm) {
                // if reference card - get image for cell
                if (isReferenceCardList && trustPin.displayAsReferenceCard && algorithm.image) {
                  let referenceCardImageName: string | null = null;

                  if (isReferenceCardList && trustPin.displayAsReferenceCard && algorithm.image) {
                    let referenceCardImageName: string | null = null;
                    // get image path if possible
                    try {
                      // try bundled image path first
                      imageName = DataController.getBundledImageData({
                        imageName: algorithm.image,
                        trust: "",
                      });
                    } catch (error) {
                      // if can't load bundled image data, try downloaded image
                      if (
                        _.findIndex(this.props.screenProps.images, (_image: any) =>
                          _image.name.includes(algorithm.GLID)
                        ) !== -1
                      ) {
                        let images = this.props.screenProps.images.filter((_image: any) =>
                          _image.name.includes(algorithm.GLID)
                        );

                        for (let i = 0; i < images.length; i++) {
                          let image = images[i];
                          if (image.name === algorithm.image) {
                            imageName = image.data;
                          }
                        }
                      }
                    }
                  }
                }

                // double size so can fit image
                if (isReferenceCardList) {
                  columnSize = "2";
                }
              }
            }
          }

          if (isMatchingAlgorithm === false) {
            continue;
          }
        } else {
          continue;
        }

        // if it matches all the above, then add it to the section
        let algorithmCell = (
          <IonCol size={columnSize} key={section.name + algorithm.id}>
            <GuidelineCell
              algorithm={algorithm}
              referenceCardImageName={imageName}
              userTrust={trust}
              searchText={this.state.searchText}
              bookmarked={algorithmBookmarkIDs.includes(algorithm.id)}
              updated={false}
              inAlgorithmList={listType === "Algorithms"}
              cellClicked={this.cellClicked.bind(this)}
              screenProps={this.props.screenProps}
            />
          </IonCol>
        );

        section.items.push(algorithmCell);

        // if algorithm matches at least one section, then add it to title matches section
        if (titleMatchSection != null && searchText.length > 1 && algorithm.name.toLowerCase().includes(searchText)) {
          titleMatchSection.items.push(algorithmCell);
        }
      }
    }

    for (let clinicalNoticeIndex = 0; clinicalNoticeIndex < clinicalNotices.length; clinicalNoticeIndex++) {
      let clinicalNotice = clinicalNotices[clinicalNoticeIndex];
      let isCNAcknowledged = DataController.isCNAcknowledged(clinicalNotice, this.props.screenProps.clinicalNoticeAcks);

      for (let sectionIndex = 0; sectionIndex < sectionItems.length; sectionIndex++) {
        let section = sectionItems[sectionIndex];

        if (section.name === "Title Matches") {
          continue;
        }

        // check if clinical notice belongs to section
        if (listType === "ClinicalNotices") {
          if (section.name === "acknowledged" && isCNAcknowledged === false) {
            continue;
          } else if (section.name === "unacknowledged" && isCNAcknowledged === true) {
            continue;
          }
        } else if (listType === "LocalClinicalUpdates") {
          // do nothing - always belong in section
        } else if (listType === "Bookmarks") {
          if (section.name !== "Clinical Notices") {
            continue;
          }
        } else if (listType === "RecentlyViewed") {
          if (section.name !== "Clinical Notices") {
            continue;
          }
        } else if (listType === "TrustPin") {
          let isCustomSection =
            section.name !== "Guidelines" && section.name !== "Clinical Notices" && section.name !== "Algorithms";
          let isMatchingClinicalNotice = false;

          if (trustPin != null) {
            if (section.name === "Clinical Notices" || isCustomSection) {
              if (isCustomSection) {
                if (
                  trustPin.clinicalNoticesInSections &&
                  trustPin.clinicalNoticesInSections.includes(clinicalNotice.ID.toString() + "_" + section)
                ) {
                  isMatchingClinicalNotice = true;
                }
              } else {
                isMatchingClinicalNotice = trustPin.clinicalNotices.includes(clinicalNotice.ID.toString());
              }
            }
          }

          if (isMatchingClinicalNotice === false) {
            continue;
          }
        } else {
          continue;
        }

        // if it matches all the above, then add it to the section
        let clinicalNoticeCell = (
          <IonCol size="1" key={clinicalNotice.ID}>
            <ClinicalNoticeCell
              clinicalNotice={clinicalNotice}
              acknowledged={isCNAcknowledged}
              searchText={this.state.searchText}
              bookmarked={clinicalNoticeBookmarkIDs.includes(clinicalNotice.ID)}
              cellClicked={this.clinicalNoticeCellClicked.bind(this)}
            />
          </IonCol>
        );

        section.items.push(clinicalNoticeCell);

        // if clinical notice matches at least one section, then add it to title matches section
        if (
          titleMatchSection != null &&
          searchText.length > 1 &&
          clinicalNotice.Title.toLowerCase().includes(searchText)
        ) {
          titleMatchSection.items.push(clinicalNoticeCell);
        }
      }
    }

    for (let pathwayIndex = 0; pathwayIndex < pathways.length; pathwayIndex++) {
      let pathway = pathways[pathwayIndex];

      for (let sectionIndex = 0; sectionIndex < sectionItems.length; sectionIndex++) {
        let section = sectionItems[sectionIndex];

        if (section.name === "Title Matches") {
          continue;
        }

        // check if pathway belongs to section
        if (listType === "Bookmarks") {
          if (section.name !== "Pathways") {
            continue;
          }
        } else if (listType === "RecentlyViewed") {
          if (section.name !== "Pathways") {
            continue;
          }
        } else {
          continue;
        }

        // if it matches all the above, then add it to the section
        let pathwayCell = (
          <IonCol size="1" key={pathway.id}>
            <PathwayCell
              pathway={pathway}
              searchText={this.state.searchText}
              bookmarked={pathwayBookmarkIDs.includes(pathway.id)}
              cellClicked={this.pathwayCellClicked.bind(this)}
            />
          </IonCol>
        );

        section.items.push(pathwayCell);

        // if pathway matches at least one section, then add it to title matches section
        if (titleMatchSection != null && searchText.length > 1 && this.pathwayMatchesSearch(pathway)) {
          titleMatchSection.items.push(pathwayCell);
        }
      }
    }

    for (let essentialSectionIndex = 0; essentialSectionIndex < essentialSections.length; essentialSectionIndex++) {
      let essentialSection = essentialSections[essentialSectionIndex];

      for (let sectionIndex = 0; sectionIndex < sectionItems.length; sectionIndex++) {
        let section = sectionItems[sectionIndex];

        if (section.name === "Title Matches") {
          continue;
        }

        // check if essentials section belongs to section
        if (listType === "Bookmarks") {
          if (section.name !== "Essentials") {
            continue;
          }
        } else if (listType === "Essentials") {
          if (
            essentialSection.Chapter === section.name ||
            (essentialSection.Chapter.includes("Chapter") === false && section.name === "End Matter")
          ) {
            // section is matching or end matter
          } else {
            continue;
          }
        } else {
          continue;
        }

        // if it matches all the above, then add it to the section
        let essentialsCell = (
          <IonCol size="1" key={essentialSection.id}>
            <EssentialsCell
              essentialSection={essentialSection}
              searchText={this.state.searchText}
              bookmarked={essentialsBookmarkIDs.includes(essentialSection.id)}
              cellClicked={this.essentialsCellClicked.bind(this)}
            />
          </IonCol>
        );
        section.items.push(essentialsCell);

        // if essentials section matches at least one section, then add it to title matches section
        if (
          titleMatchSection != null &&
          searchText.length > 1 &&
          essentialSection.Name.toLowerCase().includes(searchText)
        ) {
          titleMatchSection.items.push(essentialsCell);
        }
      }
    }

    // add sections to sectionsLayout
    for (let sectionIndex = 0; sectionIndex < sectionItems.length; sectionIndex++) {
      let section = sectionItems[sectionIndex];

      if (section.items.length > 0) {
        if (section.name !== "Title Matches") {
          resultsCount += section.items.length;
        }

        let sectionHeaderLayout = null;

        if (showSectionHeaders || (searchText.length > 1 && section.name === "Title Matches")) {
          let sectionStyle: any = {};
          let sectionColors = this.props.screenProps.sectionColors;
          let sectionColorFound = false;

          for (let sectionColor of sectionColors) {
            if (sectionColor.name === section.name) {
              sectionStyle["backgroundColor"] = sectionColor.color;
              sectionColorFound = true;
              break;
            }
          }

          sectionHeaderLayout = (
            <div className={`sectionHeader ${sectionColorFound ? "" : section.sectionClass}`} style={sectionStyle}>
              <div className="globalContentGridMargin">
                {section.title.toUpperCase()}{" "}
                {this.props.screenProps.debugMode ? <pre className="debugBox">{section.name}</pre> : ""}
              </div>
            </div>
          );
        } else if (titleMatchSection && titleMatchSection.items.length > 0 && searchText.length > 1) {
          sectionHeaderLayout = <div className={`sectionHeader sectionHeaderEmpty`}></div>;
        }

        sectionsLayout.push(
          <div key={section.name + section.sectionClass + trust} className="guidelinesContent">
            {sectionHeaderLayout}
            <div className="globalContentGridMargin">
              {section.items.length > 0 ? (
                <div className="listPageGrid">
                  <IonGrid
                    fixed
                    key={`${section + section.sectionClass}-grid`}
                    className={`${isReferenceCardList ? "referenceCardGrid" : ""}`}
                  >
                    <IonRow>{section.items}</IonRow>
                  </IonGrid>
                </div>
              ) : null}
            </div>
          </div>
        );
      }
    }

    // build list of filters
    let filterItems: IListFilterItem[] = [];

    filterItems.push({ title: "Bookmarks", value: "bookmarks", group: "My Activity", class: null });

    if (listType !== "Essentials") {
      filterItems.push({
        title: "Recently Viewed",
        value: "recentlyViewed",
        group: "My Activity",
        class: null,
      });
    }

    if (["Guidelines", "Meds"].includes(listType)) {
      if (trust !== "") {
        filterItems.push({
          title: "JRCALC",
          value: "JRCALC",
          group: "Guideline Type",
          class: null,
        });
        filterItems.push({
          title: `${DataController.getTrustDisplayName(trust)} Guidance`,
          value: "Trust Guidance",
          group: "Guideline Type",
          indentation: 1,
          class: DataController.getSectionClass(trust),
        });
        filterItems.push({
          title: `${DataController.getTrustDisplayName(trust)}`,
          value: "Trust",
          group: "Guideline Type",
          class: DataController.getSectionClass(trust),
        });
        if (
          this.props.screenProps.guidelineSummaries.find(
            (guidelineSummary) => guidelineSummary.GuidelineType === "Shared Procedure"
          ) != null
        ) {
          filterItems.push({
            title: "Shared Procedures",
            value: "Shared Procedures",
            group: "Guideline Type",
            class: DataController.getSectionClass("Shared Procedure"),
          });
        }
      }
    }

    if (listType === "Meds") {
      if (
        this.props.screenProps.guidelineSummaries.find((guidelineSummary) => DataController.isPGD(guidelineSummary)) !=
        null
      ) {
        filterItems.push({
          title: "PGDs",
          value: "PGDs",
          group: "Guideline Type",
          indentation: 1,
          class: DataController.getSectionClass(trust),
        });
      }

      if (
        this.props.screenProps.guidelineSummaries.find((guidelineSummary) => DataController.isPMA(guidelineSummary)) !=
        null
      ) {
        filterItems.push({
          title: "PMAs",
          value: "PMAs",
          group: "Guideline Type",
          indentation: 1,
          class: DataController.getSectionClass(trust),
        });
      }

      if (
        this.props.screenProps.guidelineSummaries.find(
          (guidelineSummary) => guidelineSummary.GuidelineType === "Medicines Protocol"
        )
      ) {
        filterItems.push({
          title: "Medicines Protocol",
          value: "Medicines Protocol",
          group: "Guideline Type",
          class: null,
        });
      }
    }

    // if (listType === "Guidelines" && trust === "EMAS" && this.props.screenProps.app === "Plus") {
    //   filterItems.push(
    //     // { item: "Airway", title: "Airway", class: DataController.getSectionClass(trust) },
    //     // { item: "Cardiac Care", title: "Cardiac Care", class: DataController.getSectionClass(trust) },
    //     {
    //       value: "Clinical Handover",
    //       title: "Clinical Handover",
    //       group: "Categories",
    //       class: DataController.getSectionClass(trust),
    //     },
    //     {
    //       value: "Driving",
    //       title: "Driving and Vehicle Transport Information",
    //       group: "Categories",
    //       class: DataController.getSectionClass(trust),
    //     },
    //     {
    //       value: "EPRF",
    //       title: "EPR",
    //       group: "Categories",
    //       class: DataController.getSectionClass(trust),
    //     },
    //     {
    //       value: "General",
    //       title: "General",
    //       group: "Categories",
    //       class: DataController.getSectionClass(trust),
    //     },
    //     {
    //       value: "HART",
    //       title: "HART and Major Incident",
    //       group: "Categories",
    //       class: DataController.getSectionClass(trust),
    //     },
    //     // { item: "Manual Handling", title: "Manual Handling", class: DataController.getSectionClass(trust) },
    //     // {
    //     //   item: "Mental Health and Capacity",
    //     //   title: "Mental Health and Capacity",
    //     //   class: DataController.getSectionClass(trust),
    //     // },
    //     {
    //       value: "Patient Assessment and Treatment",
    //       title: "Patient Assessment and Treatment",
    //       group: "Categories",
    //       class: DataController.getSectionClass(trust),
    //     },
    //     {
    //       value: "Paramedic Pathfinder Tools",
    //       title: "Pathfinder Tools",
    //       group: "Categories",
    //       class: DataController.getSectionClass(trust),
    //     },
    //     // {
    //     //   item: "Resuscitation",
    //     //   title: "Resuscitation - EMAS",
    //     //   class: DataController.getSectionClass(trust),
    //     // },
    //     {
    //       value: "Special Considerations",
    //       title: "Special Considerations",
    //       group: "Categories",
    //       class: DataController.getSectionClass(trust),
    //     },
    //     {
    //       value: "Specialist Paramedic",
    //       title: "Specialist Practitioner",
    //       group: "Categories",
    //       class: DataController.getSectionClass(trust),
    //     },
    //     // { item: "Stroke", title: "Stroke", class: DataController.getSectionClass(trust) },
    //     // { item: "Trauma", title: "Trauma - EMAS", class: DataController.getSectionClass(trust) },
    //     // { item: "UCA", title: "UCA", class: DataController.getSectionClass(trust) },
    //     {
    //       value: "Other",
    //       title: "Other",
    //       group: "Categories",
    //       class: DataController.getSectionClass(trust),
    //     }
    //   );
    // }

    if (listType === "Guidelines") {
      let jrcalcCategoryFilterItems = [];
      let trustCategoryFilterItems = [];
      for (let sectionItem of sectionItems) {
        if (
          sectionItem.name !== "" &&
          sectionItem.name !== "Title Matches" &&
          sectionItem.name !== "Shared Procedures" &&
          sectionItem.name !== "A-Z"
        ) {
          if (sectionItem.sectionClass === trust) {
            trustCategoryFilterItems.push({
              title: sectionItem.title,
              value: sectionItem.name,
              group: "Categories",
              class: sectionItem.sectionClass,
            });
          } else {
            jrcalcCategoryFilterItems.push({
              title: sectionItem.title,
              value: sectionItem.name,
              group: "Categories",
              class: sectionItem.sectionClass,
            });
          }
        }
      }
      filterItems = filterItems.concat(jrcalcCategoryFilterItems);
      filterItems = filterItems.concat(trustCategoryFilterItems);
      filterItems.push({
        title: "Clinical Guidelines",
        value: "Clinical Guidelines",
        group: "Guideline Type",
        class: null,
      });
      filterItems.push({
        title: "SOPs",
        value: "SOPs",
        group: "Guideline Type",
        class: null,
      });
    }

    if (listType === "Meds") {
      if (this.props.features.includes("medsStaffGroupFilter")) {
        let staffGroups = this.getMedStaffGroups();
        for (let staffGroup of staffGroups) {
          if (staffGroup !== "") {
            filterItems.push({
              title: DataController.getSectionTitle(staffGroup),
              value: staffGroup,
              group: "Staff Group",
              class: null,
            });
          }
        }
      }

      if (this.props.features.includes("customTrustMedSections")) {
        let medSections = this.getMedSections();
        for (let medSection of medSections) {
          if (medSection !== "") {
            let nonTrustSections = ["Section6"];

            filterItems.push({
              title: DataController.getSectionTitle(medSection),
              value: medSection,
              group: "Categories",
              class: DataController.getSectionClass(nonTrustSections.includes(medSection) ? medSection : trust),
            });
          }
        }
      }
    }

    if (["Meds", "PGDs", "PMAs", "SMGs"].includes(listType)) {
      filterItems.push({
        title: "Unauthorised",
        value: "Unauthorised",
        group: "Authorisation State",
        class: DataController.getSectionClass("unacknowledged"),
      });

      filterItems.push({
        title: "Authorised",
        value: "Authorised",
        group: "Authorisation State",
        class: DataController.getSectionClass("acknowledged"),
      });

      filterItems.push({
        title: "Information Only",
        value: "Information Only",
        group: "Authorisation State",
        class: DataController.getSectionClass("info-only"),
      });
      filterItems.push({
        title: "No Authorisation",
        value: "No Authorisation",
        group: "Authorisation State",
        class: DataController.getSectionClass("info-only"),
      });
    }

    if (listType === "Algorithms") {
      for (let sectionItem of sectionItems) {
        if (sectionItem.name !== "Title Matches") {
          filterItems.push({
            title: sectionItem.name,
            value: sectionItem.name,
            group: "Categories",
            class: DataController.getSectionClass("algorithms"),
          });
        }
      }
    }

    if (listType === "ClinicalNotices" || listType === "AcknowledgeableGuidelines") {
      filterItems.push({
        title: "Unacknowledged",
        value: "Unacknowledged",
        group: "Acknowledged State",
        class: DataController.getSectionClass("unacknowledged"),
      });

      filterItems.push({
        title: "Acknowledged",
        value: "Acknowledged",
        group: "Acknowledged State",
        class: DataController.getSectionClass("acknowledged"),
      });
    }

    // layout filters modal
    let filterGroups = filterItems
      .map((item) => item.group)
      .filter((value, index, self) => self.indexOf(value) === index); // unique groups

    let filterGroupsLayout = [];

    for (let filterGroup of filterGroups) {
      let filterItemsLayout = [];
      let trustCategoryFound = false;
      let filterItemsForGroup = filterItems.filter((item) => item.group === filterGroup);
      for (let filterItemIndex = 0; filterItemIndex < filterItemsForGroup.length; filterItemIndex++) {
        let filterItem = filterItemsForGroup[filterItemIndex];

        if (filterItem.group === "Categories" && filterItem.class === trust && trustCategoryFound === false) {
          trustCategoryFound = true;
          filterItemsLayout.push(
            <div className="filterSheetTrustSeparator">{DataController.getTrustDisplayName(trust)} Categories</div>
          );
        }

        let sectionStyle: any = {};
        let sectionColorFound = false;
        if (filterItem.group === "Categories") {
          let sectionColors = this.props.screenProps.sectionColors;
          for (let sectionColor of sectionColors) {
            if (sectionColor.name === filterItem.value) {
              sectionStyle["backgroundColor"] = sectionColor.color;
              sectionColorFound = true;
              break;
            }
          }
        }

        filterItemsLayout.push(
          <div
            className={`filterSheetItemRow ${filterItem.indentation ? "filterSheetItemRowIndent" : ""}`}
            onClick={() => this.filterItemChanged(filterItem)}
          >
            <div className="filterSheetItemRowStart">
              <div className={`${filterItem.class ? "filterSliver " + filterItem.class : ""}`} style={sectionStyle} />
              <div>{filterItem.title}</div>
            </div>
            <img
              className="icon-44"
              aria-label={`toggle ${filterItem.title} filter`}
              alt={`${filterGroup} filter`}
              src={
                this.state.selectedFilters.some((item) => item.value === filterItem.value)
                  ? iconTickboxActive
                  : iconTickboxInactive
              }
            />
          </div>
        );
      }
      if (filterItemsLayout.length > 0) {
        let isCollapsed = this.state.collapsedFilterGroups.includes(filterGroup);
        let disclosureIcon = iconDisclosureDown;
        if (isCollapsed) {
          if (this.props.screenProps.darkMode) {
            disclosureIcon = iconDisclosureDownDark;
          } else {
            disclosureIcon = iconDisclosureDown;
          }
        } else {
          if (this.props.screenProps.darkMode) {
            disclosureIcon = iconDisclosureUpDark;
          } else {
            disclosureIcon = iconDisclosureUp;
          }
        }

        filterGroupsLayout.push(
          <div>
            <div className="filterGroupHeader" onClick={() => this.filterGroupCollapseButtonClicked(filterGroup)}>
              <div className="filterGroupTitle">{filterGroup}</div>
              <IonButton
                mode="ios"
                aria-label={`${filterGroup} collapse button ${isCollapsed ? "open" : "close"}`}
                className="clearButton filterGroupCollapseButton"
                fill="clear"
                // on click handling set above so whole row is clickable
              >
                <img width={12} height={8} src={disclosureIcon} />
              </IonButton>
            </div>
            <Collapse isOpened={!isCollapsed}>{filterItemsLayout}</Collapse>
          </div>
        );
      }
    }

    for (let filterItemIndex = 0; filterItemIndex < filterItems.length; filterItemIndex++) {
      let filterItem = filterItems[filterItemIndex];

      let filterSectionStyle: any = {};
      let sectionColors = this.props.screenProps.sectionColors;
      let sectionColorFound = false;

      for (let sectionColor of sectionColors) {
        if (sectionColor.name === filterItem.value) {
          filterSectionStyle["backgroundColor"] = sectionColor.color;
          sectionColorFound = true;
          break;
        }
      }
    }

    // set filter and search results text
    let filterInfoText = "";

    // if (this.state.selectedFilter !== "all") {
    //   let selectedFilterItem = _.find(filterItems, {
    //     item: this.state.selectedFilter,
    //   });
    //   if (selectedFilterItem != null) {
    //     filterInfoText = `Filtered by ${selectedFilterItem.title} - `;
    //   }
    // }

    if (this.state.selectedFilters.length > 0 || (this.state.showSearch && searchText.length > 1)) {
      filterInfoText += resultsCount + " results";
    }

    if (titleMatchSection && searchText.length > 1) {
      filterInfoText += `; ${titleMatchSection.items.length} title matches, ${
        resultsCount - titleMatchSection.items.length
      } page matches`;
    }

    if (this.state.showSearch && searchText.length > 1) {
      // filterInfoText += ` for '${this.state.searchText}'`;

      if (this.state.searchText.length < 2) {
        // filterInfoText = "";
      }
    }

    let shouldShowBackButton = true;

    if (
      this.props.match.url === "/guidelines" ||
      this.props.match.url === "/meds" ||
      this.props.match.url === "/algorithms" ||
      this.props.match.url === "/pageforage" ||
      this.props.match.url === "/essentials"
    ) {
      shouldShowBackButton = false;
    }

    return (
      <IonPage>
        <IonHeader>
          <IonToolbar mode="ios" className="navBar">
            <IonButtons slot="start" className="headerButtonText" color="#FFFFFF">
              {shouldShowBackButton ? (
                <IonBackButton defaultHref={`/${this.props.match.params.tab}`} class="headerButtonText" />
              ) : null}
            </IonButtons>
            <IonButtons slot="end">
              {filterItems.length > 0 ? (
                <IonButton aria-label="filter" onClick={() => this.showFilter(true)}>
                  <img
                    className="icon-44"
                    src={this.state.selectedFilters.length > 0 ? iconFilterActive : iconFilterInactive}
                  />
                </IonButton>
              ) : null}
              <IonButton aria-label="search" onClick={() => this.toggleSearch()}>
                <img className="icon-44" src={this.state.showSearch ? iconSearchActive : iconSearchInactive} />
              </IonButton>
            </IonButtons>
            {this.state.showSearch ? (
              <div className="guidelineListSearchHeader listPageSearchHeader">
                <div className={`guidelinesSearchInputContainer`}>
                  <img alt="" src={this.props.screenProps.darkMode ? iconSearchDark : iconSearch} className="icon-44" />
                  <IonInput
                    value={this.state.searchText}
                    className="searchInputField"
                    placeholder={searchPlaceholder}
                    onIonInput={(event) => this.searchTextChanged(event)}
                    clearOnEdit={false}
                    ref={this.searchTextField}
                    onKeyDown={(event) => this.enterButtonClicked(event)}
                  />
                  {this.state.searchText ? (
                    <IonButton className="searchClearButton" mode="ios" onClick={this.clearSearch.bind(this)}>
                      <img alt="" src={iconClearSearch} className="icon-44" />
                    </IonButton>
                  ) : null}
                </div>
              </div>
            ) : (
              <IonTitle>{pageTitle}</IonTitle>
            )}
          </IonToolbar>

          <div className="filterInfoContainer">
            {this.state.selectedFilters.length > 0 ? (
              <div className="listFilterChipContainer globalContentMargin">
                {this.state.selectedFilters.map((filterItem, i: number) => (
                  <div className="listFilterChip" onClick={() => this.filterItemChanged(filterItem)}>
                    <div className="listFilterChipTitle">{filterItem.title}</div>
                    <img alt="" src={buttonCloseBlue} className="icon-8" />
                  </div>
                ))}
              </div>
            ) : null}

            {filterInfoText !== "" ? (
              <div className="filterTextContainer globalContentMargin">
                <div className="filterInfoText">{filterInfoText}</div>
                <IonButton
                  mode="ios"
                  className="clearButton resetFilterButton"
                  onClick={this.resetFilterAndSearch.bind(this)}
                >
                  Reset
                </IonButton>
              </div>
            ) : null}
          </div>
        </IonHeader>

        <IonContent fullscreen>
          {this.props.listType === "Essentials" ? (
            <div className="essentialsHeaderDiv">
              <div className="globalContentMargin">
                <span className="essentialsHeaderText">{"First Responder Care "}</span>
                <span className="essentialsHeaderText essentialsHeaderTextGreen">{"Essentials"}</span>
              </div>
            </div>
          ) : null}

          {sectionsLayout}
        </IonContent>

        <IonModal
          id="listFilterModal"
          isOpen={this.state.showFilter}
          onDidDismiss={() => this.setState({ showFilter: false })}
          mode="ios"
        >
          <IonHeader>
            <IonToolbar mode="ios" color="#F7961E" className="modalHeader navBar">
              <IonButtons slot="start">
                <IonButton
                  mode="ios"
                  className="clearButton toolbarButton filterSheetDoneButton"
                  aria-label="close"
                  onClick={() => this.showFilter(false)}
                >
                  <img className="icon-44" src={iconClose} />
                </IonButton>
              </IonButtons>
              <IonTitle className="headerTitle">Filter</IonTitle>
              <IonButtons slot="end">
                <IonButton
                  mode="ios"
                  disabled={this.state.selectedFilters.length === 0}
                  className="clearButton toolbarButton filterSheetResetButton"
                  onClick={() => this.resetFilter()}
                >
                  Reset
                </IonButton>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent>
            <div className="filterSheetGroupsContainer">{filterGroupsLayout}</div>
            <IonButton
              mode="ios"
              className="filledButton filterSheetFilterButton"
              strong={true}
              onClick={() => {
                this.showFilter(false);
              }}
            >
              {this.state.selectedFilters.length > 0
                ? `Filter (${resultsCount} results)`
                : `Show all (${resultsCount} results)`}
            </IonButton>
          </IonContent>
        </IonModal>
      </IonPage>
    );
  }
}

export default withRouter(withIonLifeCycle(ListPage));
